import { defineComponent as Or, computed as Lr, h as Br } from "vue";
const Tr = (e) => {
  window.RevolugoElements = {
    ...window.RevolugoElements,
    ready: (n) => {
      const i = window.RevolugoElements?._ready;
      window.RevolugoElements._ready = () => {
        i && i(), n();
      };
    }
  };
  const a = document.createElement("script");
  a.src = e, a.type = "module", a.async = !1;
  const [t] = document.querySelectorAll("script");
  return t ? t?.parentNode?.insertBefore(a, t) : document.head.append(a), a;
}, $r = (e) => {
  const a = (e ? process.env.ELEMENTS_NEXT_ENTRY_URL : "https://cdn.jsdelivr.net/npm/@revolugo/elements@%V/dist/revolugo.min.js").replace("%V", "6.10.7"), t = [...document.querySelectorAll("script")].find((n) => n.src.includes(a));
  return new Promise((n) => {
    if (t) {
      n(!0);
      return;
    }
    Tr(a).addEventListener("load", () => {
      n(!0);
    });
  });
}, zr = new RegExp("([\\p{Ll}\\d])(\\p{Lu})", "gu"), Er = new RegExp("(\\p{Lu})([\\p{Lu}][\\p{Ll}])", "gu"), wr = new RegExp("(\\d)\\p{Ll}|(\\p{L})\\d", "u"), _r = /[^\p{L}\d]+/giu, ha = "$1\0$2", ya = "";
function ot(e) {
  let a = e.trim();
  a = a.replace(zr, ha).replace(Er, ha), a = a.replace(_r, "\0");
  let t = 0, n = a.length;
  for (; a.charAt(t) === "\0"; )
    t++;
  if (t === n)
    return [];
  for (; a.charAt(n - 1) === "\0"; )
    n--;
  return a.slice(t, n).split(/\0/g);
}
function Kr(e) {
  const a = ot(e);
  for (let t = 0; t < a.length; t++) {
    const n = a[t], i = wr.exec(n);
    if (i) {
      const s = i.index + (i[1] ?? i[2]).length;
      a.splice(t, 1, n.slice(0, s), n.slice(s));
    }
  }
  return a;
}
function lt(e, a) {
  const [t, n, i] = He(e, a);
  return t + n.map(Fe(a?.locale)).join(a?.delimiter ?? " ") + i;
}
function Fr(e, a) {
  const [t, n, i] = He(e, a), s = Fe(a?.locale), o = Xe(a?.locale), l = a?.mergeAmbiguousCharacters ? Qe(s, o) : ut(s, o);
  return t + n.map((u, m) => m === 0 ? s(u) : l(u, m)).join(a?.delimiter ?? "") + i;
}
function Hr(e, a) {
  const [t, n, i] = He(e, a), s = Fe(a?.locale), o = Xe(a?.locale), l = a?.mergeAmbiguousCharacters ? Qe(s, o) : ut(s, o);
  return t + n.map(l).join(a?.delimiter ?? "") + i;
}
function Ur(e, a) {
  const [t, n, i] = He(e, a), s = Fe(a?.locale), o = Xe(a?.locale);
  return t + n.map(Qe(s, o)).join(a?.delimiter ?? " ") + i;
}
function st(e, a) {
  return lt(e, { delimiter: "-", ...a });
}
function Gr(e, a) {
  return lt(e, { delimiter: "_", ...a });
}
function Fe(e) {
  return e === !1 ? (a) => a.toLowerCase() : (a) => a.toLocaleLowerCase(e);
}
function Xe(e) {
  return e === !1 ? (a) => a.toUpperCase() : (a) => a.toLocaleUpperCase(e);
}
function Qe(e, a) {
  return (t) => `${a(t[0])}${e(t.slice(1))}`;
}
function ut(e, a) {
  return (t, n) => {
    const i = t[0];
    return (n > 0 && i >= "0" && i <= "9" ? "_" + i : a(i)) + e(t.slice(1));
  };
}
function He(e, a = {}) {
  const t = a.split ?? (a.separateNumbers ? Kr : ot), n = a.prefixCharacters ?? ya, i = a.suffixCharacters ?? ya;
  let s = 0, o = e.length;
  for (; s < e.length; ) {
    const l = e.charAt(s);
    if (!n.includes(l))
      break;
    s++;
  }
  for (; o > s; ) {
    const l = o - 1, u = e.charAt(l);
    if (!i.includes(u))
      break;
    o = l;
  }
  return [
    e.slice(0, s),
    t(e.slice(s, o)),
    e.slice(o)
  ];
}
function I(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var ye = { exports: {} }, jr = ye.exports, Sa;
function kr() {
  return Sa || (Sa = 1, (function(e, a) {
    (function(t, n, i) {
      e.exports = i(), e.exports.default = i();
    })("slugify", jr, function() {
      var t = JSON.parse(`{"$":"dollar","%":"percent","&":"and","<":"less",">":"greater","|":"or","¢":"cent","£":"pound","¤":"currency","¥":"yen","©":"(c)","ª":"a","®":"(r)","º":"o","À":"A","Á":"A","Â":"A","Ã":"A","Ä":"A","Å":"A","Æ":"AE","Ç":"C","È":"E","É":"E","Ê":"E","Ë":"E","Ì":"I","Í":"I","Î":"I","Ï":"I","Ð":"D","Ñ":"N","Ò":"O","Ó":"O","Ô":"O","Õ":"O","Ö":"O","Ø":"O","Ù":"U","Ú":"U","Û":"U","Ü":"U","Ý":"Y","Þ":"TH","ß":"ss","à":"a","á":"a","â":"a","ã":"a","ä":"a","å":"a","æ":"ae","ç":"c","è":"e","é":"e","ê":"e","ë":"e","ì":"i","í":"i","î":"i","ï":"i","ð":"d","ñ":"n","ò":"o","ó":"o","ô":"o","õ":"o","ö":"o","ø":"o","ù":"u","ú":"u","û":"u","ü":"u","ý":"y","þ":"th","ÿ":"y","Ā":"A","ā":"a","Ă":"A","ă":"a","Ą":"A","ą":"a","Ć":"C","ć":"c","Č":"C","č":"c","Ď":"D","ď":"d","Đ":"DJ","đ":"dj","Ē":"E","ē":"e","Ė":"E","ė":"e","Ę":"e","ę":"e","Ě":"E","ě":"e","Ğ":"G","ğ":"g","Ģ":"G","ģ":"g","Ĩ":"I","ĩ":"i","Ī":"i","ī":"i","Į":"I","į":"i","İ":"I","ı":"i","Ķ":"k","ķ":"k","Ļ":"L","ļ":"l","Ľ":"L","ľ":"l","Ł":"L","ł":"l","Ń":"N","ń":"n","Ņ":"N","ņ":"n","Ň":"N","ň":"n","Ō":"O","ō":"o","Ő":"O","ő":"o","Œ":"OE","œ":"oe","Ŕ":"R","ŕ":"r","Ř":"R","ř":"r","Ś":"S","ś":"s","Ş":"S","ş":"s","Š":"S","š":"s","Ţ":"T","ţ":"t","Ť":"T","ť":"t","Ũ":"U","ũ":"u","Ū":"u","ū":"u","Ů":"U","ů":"u","Ű":"U","ű":"u","Ų":"U","ų":"u","Ŵ":"W","ŵ":"w","Ŷ":"Y","ŷ":"y","Ÿ":"Y","Ź":"Z","ź":"z","Ż":"Z","ż":"z","Ž":"Z","ž":"z","Ə":"E","ƒ":"f","Ơ":"O","ơ":"o","Ư":"U","ư":"u","ǈ":"LJ","ǉ":"lj","ǋ":"NJ","ǌ":"nj","Ș":"S","ș":"s","Ț":"T","ț":"t","ə":"e","˚":"o","Ά":"A","Έ":"E","Ή":"H","Ί":"I","Ό":"O","Ύ":"Y","Ώ":"W","ΐ":"i","Α":"A","Β":"B","Γ":"G","Δ":"D","Ε":"E","Ζ":"Z","Η":"H","Θ":"8","Ι":"I","Κ":"K","Λ":"L","Μ":"M","Ν":"N","Ξ":"3","Ο":"O","Π":"P","Ρ":"R","Σ":"S","Τ":"T","Υ":"Y","Φ":"F","Χ":"X","Ψ":"PS","Ω":"W","Ϊ":"I","Ϋ":"Y","ά":"a","έ":"e","ή":"h","ί":"i","ΰ":"y","α":"a","β":"b","γ":"g","δ":"d","ε":"e","ζ":"z","η":"h","θ":"8","ι":"i","κ":"k","λ":"l","μ":"m","ν":"n","ξ":"3","ο":"o","π":"p","ρ":"r","ς":"s","σ":"s","τ":"t","υ":"y","φ":"f","χ":"x","ψ":"ps","ω":"w","ϊ":"i","ϋ":"y","ό":"o","ύ":"y","ώ":"w","Ё":"Yo","Ђ":"DJ","Є":"Ye","І":"I","Ї":"Yi","Ј":"J","Љ":"LJ","Њ":"NJ","Ћ":"C","Џ":"DZ","А":"A","Б":"B","В":"V","Г":"G","Д":"D","Е":"E","Ж":"Zh","З":"Z","И":"I","Й":"J","К":"K","Л":"L","М":"M","Н":"N","О":"O","П":"P","Р":"R","С":"S","Т":"T","У":"U","Ф":"F","Х":"H","Ц":"C","Ч":"Ch","Ш":"Sh","Щ":"Sh","Ъ":"U","Ы":"Y","Ь":"","Э":"E","Ю":"Yu","Я":"Ya","а":"a","б":"b","в":"v","г":"g","д":"d","е":"e","ж":"zh","з":"z","и":"i","й":"j","к":"k","л":"l","м":"m","н":"n","о":"o","п":"p","р":"r","с":"s","т":"t","у":"u","ф":"f","х":"h","ц":"c","ч":"ch","ш":"sh","щ":"sh","ъ":"u","ы":"y","ь":"","э":"e","ю":"yu","я":"ya","ё":"yo","ђ":"dj","є":"ye","і":"i","ї":"yi","ј":"j","љ":"lj","њ":"nj","ћ":"c","ѝ":"u","џ":"dz","Ґ":"G","ґ":"g","Ғ":"GH","ғ":"gh","Қ":"KH","қ":"kh","Ң":"NG","ң":"ng","Ү":"UE","ү":"ue","Ұ":"U","ұ":"u","Һ":"H","һ":"h","Ә":"AE","ә":"ae","Ө":"OE","ө":"oe","Ա":"A","Բ":"B","Գ":"G","Դ":"D","Ե":"E","Զ":"Z","Է":"E'","Ը":"Y'","Թ":"T'","Ժ":"JH","Ի":"I","Լ":"L","Խ":"X","Ծ":"C'","Կ":"K","Հ":"H","Ձ":"D'","Ղ":"GH","Ճ":"TW","Մ":"M","Յ":"Y","Ն":"N","Շ":"SH","Չ":"CH","Պ":"P","Ջ":"J","Ռ":"R'","Ս":"S","Վ":"V","Տ":"T","Ր":"R","Ց":"C","Փ":"P'","Ք":"Q'","Օ":"O''","Ֆ":"F","և":"EV","ء":"a","آ":"aa","أ":"a","ؤ":"u","إ":"i","ئ":"e","ا":"a","ب":"b","ة":"h","ت":"t","ث":"th","ج":"j","ح":"h","خ":"kh","د":"d","ذ":"th","ر":"r","ز":"z","س":"s","ش":"sh","ص":"s","ض":"dh","ط":"t","ظ":"z","ع":"a","غ":"gh","ف":"f","ق":"q","ك":"k","ل":"l","م":"m","ن":"n","ه":"h","و":"w","ى":"a","ي":"y","ً":"an","ٌ":"on","ٍ":"en","َ":"a","ُ":"u","ِ":"e","ْ":"","٠":"0","١":"1","٢":"2","٣":"3","٤":"4","٥":"5","٦":"6","٧":"7","٨":"8","٩":"9","پ":"p","چ":"ch","ژ":"zh","ک":"k","گ":"g","ی":"y","۰":"0","۱":"1","۲":"2","۳":"3","۴":"4","۵":"5","۶":"6","۷":"7","۸":"8","۹":"9","฿":"baht","ა":"a","ბ":"b","გ":"g","დ":"d","ე":"e","ვ":"v","ზ":"z","თ":"t","ი":"i","კ":"k","ლ":"l","მ":"m","ნ":"n","ო":"o","პ":"p","ჟ":"zh","რ":"r","ს":"s","ტ":"t","უ":"u","ფ":"f","ქ":"k","ღ":"gh","ყ":"q","შ":"sh","ჩ":"ch","ც":"ts","ძ":"dz","წ":"ts","ჭ":"ch","ხ":"kh","ჯ":"j","ჰ":"h","Ṣ":"S","ṣ":"s","Ẁ":"W","ẁ":"w","Ẃ":"W","ẃ":"w","Ẅ":"W","ẅ":"w","ẞ":"SS","Ạ":"A","ạ":"a","Ả":"A","ả":"a","Ấ":"A","ấ":"a","Ầ":"A","ầ":"a","Ẩ":"A","ẩ":"a","Ẫ":"A","ẫ":"a","Ậ":"A","ậ":"a","Ắ":"A","ắ":"a","Ằ":"A","ằ":"a","Ẳ":"A","ẳ":"a","Ẵ":"A","ẵ":"a","Ặ":"A","ặ":"a","Ẹ":"E","ẹ":"e","Ẻ":"E","ẻ":"e","Ẽ":"E","ẽ":"e","Ế":"E","ế":"e","Ề":"E","ề":"e","Ể":"E","ể":"e","Ễ":"E","ễ":"e","Ệ":"E","ệ":"e","Ỉ":"I","ỉ":"i","Ị":"I","ị":"i","Ọ":"O","ọ":"o","Ỏ":"O","ỏ":"o","Ố":"O","ố":"o","Ồ":"O","ồ":"o","Ổ":"O","ổ":"o","Ỗ":"O","ỗ":"o","Ộ":"O","ộ":"o","Ớ":"O","ớ":"o","Ờ":"O","ờ":"o","Ở":"O","ở":"o","Ỡ":"O","ỡ":"o","Ợ":"O","ợ":"o","Ụ":"U","ụ":"u","Ủ":"U","ủ":"u","Ứ":"U","ứ":"u","Ừ":"U","ừ":"u","Ử":"U","ử":"u","Ữ":"U","ữ":"u","Ự":"U","ự":"u","Ỳ":"Y","ỳ":"y","Ỵ":"Y","ỵ":"y","Ỷ":"Y","ỷ":"y","Ỹ":"Y","ỹ":"y","–":"-","‘":"'","’":"'","“":"\\"","”":"\\"","„":"\\"","†":"+","•":"*","…":"...","₠":"ecu","₢":"cruzeiro","₣":"french franc","₤":"lira","₥":"mill","₦":"naira","₧":"peseta","₨":"rupee","₩":"won","₪":"new shequel","₫":"dong","€":"euro","₭":"kip","₮":"tugrik","₯":"drachma","₰":"penny","₱":"peso","₲":"guarani","₳":"austral","₴":"hryvnia","₵":"cedi","₸":"kazakhstani tenge","₹":"indian rupee","₺":"turkish lira","₽":"russian ruble","₿":"bitcoin","℠":"sm","™":"tm","∂":"d","∆":"delta","∑":"sum","∞":"infinity","♥":"love","元":"yuan","円":"yen","﷼":"rial","ﻵ":"laa","ﻷ":"laa","ﻹ":"lai","ﻻ":"la"}`), n = JSON.parse('{"bg":{"Й":"Y","Ц":"Ts","Щ":"Sht","Ъ":"A","Ь":"Y","й":"y","ц":"ts","щ":"sht","ъ":"a","ь":"y"},"de":{"Ä":"AE","ä":"ae","Ö":"OE","ö":"oe","Ü":"UE","ü":"ue","ß":"ss","%":"prozent","&":"und","|":"oder","∑":"summe","∞":"unendlich","♥":"liebe"},"es":{"%":"por ciento","&":"y","<":"menor que",">":"mayor que","|":"o","¢":"centavos","£":"libras","¤":"moneda","₣":"francos","∑":"suma","∞":"infinito","♥":"amor"},"fr":{"%":"pourcent","&":"et","<":"plus petit",">":"plus grand","|":"ou","¢":"centime","£":"livre","¤":"devise","₣":"franc","∑":"somme","∞":"infini","♥":"amour"},"pt":{"%":"porcento","&":"e","<":"menor",">":"maior","|":"ou","¢":"centavo","∑":"soma","£":"libra","∞":"infinito","♥":"amor"},"uk":{"И":"Y","и":"y","Й":"Y","й":"y","Ц":"Ts","ц":"ts","Х":"Kh","х":"kh","Щ":"Shch","щ":"shch","Г":"H","г":"h"},"vi":{"Đ":"D","đ":"d"},"da":{"Ø":"OE","ø":"oe","Å":"AA","å":"aa","%":"procent","&":"og","|":"eller","$":"dollar","<":"mindre end",">":"større end"},"nb":{"&":"og","Å":"AA","Æ":"AE","Ø":"OE","å":"aa","æ":"ae","ø":"oe"},"it":{"&":"e"},"nl":{"&":"en"},"sv":{"&":"och","Å":"AA","Ä":"AE","Ö":"OE","å":"aa","ä":"ae","ö":"oe"}}');
      function i(s, o) {
        if (typeof s != "string")
          throw new Error("slugify: string argument expected");
        o = typeof o == "string" ? { replacement: o } : o || {};
        var l = n[o.locale] || {}, u = o.replacement === void 0 ? "-" : o.replacement, m = o.trim === void 0 ? !0 : o.trim, D = s.normalize().split("").reduce(function(h, p) {
          var y = l[p];
          return y === void 0 && (y = t[p]), y === void 0 && (y = p), y === u && (y = " "), h + y.replace(o.remove || /[^\w\s$*_+~.()'"!\-:@]+/g, "");
        }, "");
        return o.strict && (D = D.replace(/[^A-Za-z0-9\s]/g, "")), m && (D = D.trim()), D = D.replace(/\s+/g, u), o.lower && (D = D.toLowerCase()), D;
      }
      return i.extend = function(s) {
        Object.assign(t, s);
      }, i;
    });
  })(ye)), ye.exports;
}
var Yr = kr();
const xr = /* @__PURE__ */ I(Yr);
function Ir(e) {
  return xr(st(e), {
    lower: !0,
    strict: !0
  });
}
var ct = /* @__PURE__ */ ((e) => (e.Camel = "camelCase", e.Capital = "capitalCase", e.Param = "paramCase", e.Pascal = "pascalCase", e.Slug = "slugCase", e.Snake = "snakeCase", e))(ct || {});
const Cr = {
  camelCase: Fr,
  capitalCase: Ur,
  paramCase: st,
  pascalCase: Hr,
  slugCase: Ir,
  snakeCase: Gr
};
function Zr(e, a) {
  return e.some(
    (t) => typeof t == "string" ? t === a : t.test(a)
  );
}
function Vr(e) {
  return e === Object(e) && !Array.isArray(e) && typeof e != "function";
}
function Ie(e, a, t = { deep: !0 }) {
  return Vr(e) ? Object.keys(e).reduce((n, i) => {
    const s = t?.exclude && Zr(t.exclude, i) ? i : Cr[a](i);
    return n[s] = t.deep ? Ie(e[i], a, t) : e[i], n;
  }, {}) : Array.isArray(e) ? e.map((n) => Ie(n, a, t)) : e;
}
var r = /* @__PURE__ */ ((e) => (e.AED = "AED", e.AFN = "AFN", e.ALL = "ALL", e.AMD = "AMD", e.ANG = "ANG", e.AOA = "AOA", e.ARS = "ARS", e.AUD = "AUD", e.AWG = "AWG", e.AZN = "AZN", e.BAM = "BAM", e.BBD = "BBD", e.BDT = "BDT", e.BGN = "BGN", e.BHD = "BHD", e.BIF = "BIF", e.BMD = "BMD", e.BND = "BND", e.BOB = "BOB", e.BRL = "BRL", e.BSD = "BSD", e.BTN = "BTN", e.BWP = "BWP", e.BYN = "BYN", e.BYR = "BYR", e.BZD = "BZD", e.CAD = "CAD", e.CDF = "CDF", e.CHF = "CHF", e.CLF = "CLF", e.CLP = "CLP", e.CNY = "CNY", e.COP = "COP", e.CRC = "CRC", e.CUC = "CUC", e.CUP = "CUP", e.CVE = "CVE", e.CZK = "CZK", e.DJF = "DJF", e.DKK = "DKK", e.DOP = "DOP", e.DZD = "DZD", e.EEK = "EEK", e.EGP = "EGP", e.ERN = "ERN", e.ETB = "ETB", e.EUR = "EUR", e.FJD = "FJD", e.FKP = "FKP", e.GBP = "GBP", e.GEL = "GEL", e.GHS = "GHS", e.GIP = "GIP", e.GMD = "GMD", e.GNF = "GNF", e.GTQ = "GTQ", e.GYD = "GYD", e.HKD = "HKD", e.HNL = "HNL", e.HRK = "HRK", e.HTG = "HTG", e.HUF = "HUF", e.IDR = "IDR", e.ILS = "ILS", e.INR = "INR", e.IQD = "IQD", e.IRR = "IRR", e.ISK = "ISK", e.JMD = "JMD", e.JOD = "JOD", e.JPY = "JPY", e.KES = "KES", e.KGS = "KGS", e.KHR = "KHR", e.KMF = "KMF", e.KPW = "KPW", e.KRW = "KRW", e.KWD = "KWD", e.KYD = "KYD", e.KZT = "KZT", e.LAK = "LAK", e.LBP = "LBP", e.LKR = "LKR", e.LRD = "LRD", e.LSL = "LSL", e.LTL = "LTL", e.LVL = "LVL", e.LYD = "LYD", e.MAD = "MAD", e.MDL = "MDL", e.MGA = "MGA", e.MKD = "MKD", e.MMK = "MMK", e.MNT = "MNT", e.MOP = "MOP", e.MRO = "MRO", e.MRU = "MRU", e.MUR = "MUR", e.MVR = "MVR", e.MWK = "MWK", e.MXN = "MXN", e.MYR = "MYR", e.MZN = "MZN", e.NAD = "NAD", e.NGN = "NGN", e.NIO = "NIO", e.NOK = "NOK", e.NPR = "NPR", e.NZD = "NZD", e.OMR = "OMR", e.PAB = "PAB", e.PEN = "PEN", e.PGK = "PGK", e.PHP = "PHP", e.PKR = "PKR", e.PLN = "PLN", e.PYG = "PYG", e.QAR = "QAR", e.RON = "RON", e.RSD = "RSD", e.RUB = "RUB", e.RWF = "RWF", e.SAR = "SAR", e.SBD = "SBD", e.SCR = "SCR", e.SDG = "SDG", e.SEK = "SEK", e.SGD = "SGD", e.SHP = "SHP", e.SLL = "SLL", e.SOS = "SOS", e.SRD = "SRD", e.SSP = "SSP", e.STD = "STD", e.SYP = "SYP", e.SZL = "SZL", e.THB = "THB", e.TJS = "TJS", e.TMT = "TMT", e.TND = "TND", e.TOP = "TOP", e.TRY = "TRY", e.TTD = "TTD", e.TWD = "TWD", e.TZS = "TZS", e.UAH = "UAH", e.UGX = "UGX", e.USD = "USD", e.UYU = "UYU", e.UZS = "UZS", e.VEF = "VEF", e.VES = "VES", e.VND = "VND", e.VUV = "VUV", e.WST = "WST", e.XAF = "XAF", e.XCD = "XCD", e.XOF = "XOF", e.XPF = "XPF", e.YER = "YER", e.ZAR = "ZAR", e.ZMK = "ZMK", e.ZMW = "ZMW", e.ZWL = "ZWL", e))(r || {});
function Wr(e, a) {
  const t = {};
  for (const n of a)
    Object.hasOwn(e, n) && (t[n] = e[n]);
  return t;
}
const ea = {
  AED: {
    code: r.AED,
    decimalDigits: 2,
    name: "United Arab Emirates Dirham",
    namePlural: "UAE dirhams",
    rounding: 0,
    symbol: "AED",
    symbolNative: "د.إ.‏",
    zeroDecimal: !1
  },
  AFN: {
    code: r.AFN,
    decimalDigits: 0,
    name: "Afghan Afghani",
    namePlural: "Afghan Afghanis",
    rounding: 0,
    symbol: "Af",
    symbolNative: "؋",
    zeroDecimal: !1
  },
  ALL: {
    code: r.ALL,
    decimalDigits: 0,
    name: "Albanian Lek",
    namePlural: "Albanian lekë",
    rounding: 0,
    symbol: "ALL",
    symbolNative: "Lek",
    zeroDecimal: !1
  },
  AMD: {
    code: r.AMD,
    decimalDigits: 0,
    name: "Armenian Dram",
    namePlural: "Armenian drams",
    rounding: 0,
    symbol: "AMD",
    symbolNative: "դր.",
    zeroDecimal: !1
  },
  ANG: {
    code: r.ANG,
    decimalDigits: 2,
    name: "Netherlands Antillean Guilder",
    namePlural: "Netherlands Antillean guilders",
    rounding: 0,
    symbol: "ANG",
    symbolNative: "NAf.",
    zeroDecimal: !1
  },
  AOA: {
    code: r.AOA,
    decimalDigits: 2,
    name: "Angolan Kwanza",
    namePlural: "Angolan kwanzas",
    rounding: 0,
    symbol: "AOA",
    symbolNative: "Kz",
    zeroDecimal: !1
  },
  ARS: {
    code: r.ARS,
    decimalDigits: 2,
    name: "Argentine Peso",
    namePlural: "Argentine pesos",
    rounding: 0,
    symbol: "AR$",
    symbolNative: "$",
    zeroDecimal: !1
  },
  AUD: {
    code: r.AUD,
    decimalDigits: 2,
    name: "Australian Dollar",
    namePlural: "Australian dollars",
    rounding: 0,
    symbol: "AU$",
    symbolNative: "$",
    zeroDecimal: !1
  },
  AWG: {
    code: r.AWG,
    decimalDigits: 2,
    name: "Aruban Florin",
    namePlural: "Aruban florin",
    rounding: 0,
    symbol: "AWG",
    symbolNative: "Afl.",
    zeroDecimal: !1
  },
  AZN: {
    code: r.AZN,
    decimalDigits: 2,
    name: "Azerbaijani Manat",
    namePlural: "Azerbaijani manats",
    rounding: 0,
    symbol: "man.",
    symbolNative: "ман.",
    zeroDecimal: !1
  },
  BAM: {
    code: r.BAM,
    decimalDigits: 2,
    name: "Bosnia-Herzegovina Convertible Mark",
    namePlural: "Bosnia-Herzegovina convertible marks",
    rounding: 0,
    symbol: "KM",
    symbolNative: "KM",
    zeroDecimal: !1
  },
  BBD: {
    code: r.BBD,
    decimalDigits: 2,
    name: "Barbadian Dollar",
    namePlural: "Barbadian dollars",
    rounding: 0,
    symbol: "BBD",
    symbolNative: "$",
    zeroDecimal: !1
  },
  BDT: {
    code: r.BDT,
    decimalDigits: 2,
    name: "Bangladeshi Taka",
    namePlural: "Bangladeshi takas",
    rounding: 0,
    symbol: "Tk",
    symbolNative: "৳",
    zeroDecimal: !1
  },
  BGN: {
    code: r.BGN,
    decimalDigits: 2,
    name: "Bulgarian Lev",
    namePlural: "Bulgarian leva",
    rounding: 0,
    symbol: "BGN",
    symbolNative: "лв.",
    zeroDecimal: !1
  },
  BHD: {
    code: r.BHD,
    decimalDigits: 3,
    name: "Bahraini Dinar",
    namePlural: "Bahraini dinars",
    rounding: 0,
    symbol: "BD",
    symbolNative: "د.ب.‏",
    zeroDecimal: !1
  },
  BIF: {
    code: r.BIF,
    decimalDigits: 0,
    name: "Burundian Franc",
    namePlural: "Burundian francs",
    rounding: 0,
    symbol: "FBu",
    symbolNative: "FBu",
    zeroDecimal: !0
  },
  BMD: {
    code: r.BMD,
    decimalDigits: 2,
    name: "Bermudan Dollar",
    namePlural: "Bermudan dollars",
    rounding: 0,
    symbol: "BMD",
    symbolNative: "$",
    zeroDecimal: !1
  },
  BND: {
    code: r.BND,
    decimalDigits: 2,
    name: "Brunei Dollar",
    namePlural: "Brunei dollars",
    rounding: 0,
    symbol: "BN$",
    symbolNative: "$",
    zeroDecimal: !1
  },
  BOB: {
    code: r.BOB,
    decimalDigits: 2,
    name: "Bolivian Boliviano",
    namePlural: "Bolivian bolivianos",
    rounding: 0,
    symbol: "Bs",
    symbolNative: "Bs",
    zeroDecimal: !1
  },
  BRL: {
    code: r.BRL,
    decimalDigits: 2,
    name: "Brazilian Real",
    namePlural: "Brazilian reals",
    rounding: 0,
    symbol: "R$",
    symbolNative: "R$",
    zeroDecimal: !1
  },
  BSD: {
    code: r.BSD,
    decimalDigits: 2,
    name: "Bahamian Dollar",
    namePlural: "Bahamian dollars",
    rounding: 0,
    symbol: "BSD",
    symbolNative: "$",
    zeroDecimal: !1
  },
  BTN: {
    code: r.BTN,
    decimalDigits: 2,
    name: "Bhutanese Ngultrum",
    namePlural: "Bhutanese ngultrums",
    rounding: 0,
    symbol: "BTN",
    symbolNative: "Nu.",
    zeroDecimal: !1
  },
  BWP: {
    code: r.BWP,
    decimalDigits: 2,
    name: "Botswanan Pula",
    namePlural: "Botswanan pulas",
    rounding: 0,
    symbol: "BWP",
    symbolNative: "P",
    zeroDecimal: !1
  },
  BYN: {
    code: r.BYN,
    decimalDigits: 2,
    name: "Belarusian Ruble",
    namePlural: "Belarusian rubles",
    rounding: 0,
    symbol: "Br",
    symbolNative: "руб.",
    zeroDecimal: !1
  },
  BYR: {
    code: r.BYR,
    decimalDigits: 0,
    deprecated: !0,
    name: "Belarusian Ruble",
    namePlural: "Belarusian rubles",
    rounding: 0,
    symbol: "BYR",
    symbolNative: "BYR",
    zeroDecimal: !1
  },
  BZD: {
    code: r.BZD,
    decimalDigits: 2,
    name: "Belize Dollar",
    namePlural: "Belize dollars",
    rounding: 0,
    symbol: "BZ$",
    symbolNative: "$",
    zeroDecimal: !1
  },
  CAD: {
    code: r.CAD,
    decimalDigits: 2,
    name: "Canadian Dollar",
    namePlural: "Canadian dollars",
    rounding: 0,
    symbol: "CA$",
    symbolNative: "$",
    zeroDecimal: !1
  },
  CDF: {
    code: r.CDF,
    decimalDigits: 2,
    name: "Congolese Franc",
    namePlural: "Congolese francs",
    rounding: 0,
    symbol: "CDF",
    symbolNative: "FrCD",
    zeroDecimal: !1
  },
  CHF: {
    code: r.CHF,
    decimalDigits: 2,
    name: "Swiss Franc",
    namePlural: "Swiss francs",
    rounding: 0.05,
    symbol: "CHF",
    symbolNative: "CHF",
    zeroDecimal: !1
  },
  CLF: {
    code: r.CLF,
    decimalDigits: 4,
    deprecated: !0,
    name: "Chilean Unit of Account (UF)",
    namePlural: "Chilean units of account (UF)",
    rounding: 0,
    symbol: "CLF",
    symbolNative: "CLF",
    zeroDecimal: !1
  },
  CLP: {
    code: r.CLP,
    decimalDigits: 0,
    name: "Chilean Peso",
    namePlural: "Chilean pesos",
    rounding: 0,
    symbol: "CL$",
    symbolNative: "$",
    zeroDecimal: !0
  },
  CNY: {
    code: r.CNY,
    decimalDigits: 2,
    name: "Chinese Yuan",
    namePlural: "Chinese yuan",
    rounding: 0,
    symbol: "CN¥",
    symbolNative: "CN¥",
    zeroDecimal: !1
  },
  COP: {
    code: r.COP,
    decimalDigits: 0,
    name: "Colombian Peso",
    namePlural: "Colombian pesos",
    rounding: 0,
    symbol: "CO$",
    symbolNative: "$",
    zeroDecimal: !1
  },
  CRC: {
    code: r.CRC,
    decimalDigits: 0,
    name: "Costa Rican Colón",
    namePlural: "Costa Rican colóns",
    rounding: 0,
    symbol: "₡",
    symbolNative: "₡",
    zeroDecimal: !1
  },
  CUC: {
    code: r.CUC,
    decimalDigits: 2,
    name: "Cuban Convertible Peso",
    namePlural: "Cuban convertible pesos",
    rounding: 0,
    symbol: "CUC",
    symbolNative: "CUC",
    zeroDecimal: !1
  },
  CUP: {
    code: r.CUP,
    decimalDigits: 2,
    name: "Cuban Peso",
    namePlural: "Cuban pesos",
    rounding: 0,
    symbol: "CUP",
    symbolNative: "$",
    zeroDecimal: !1
  },
  CVE: {
    code: r.CVE,
    decimalDigits: 2,
    name: "Cape Verdean Escudo",
    namePlural: "Cape Verdean escudos",
    rounding: 0,
    symbol: "CV$",
    symbolNative: "CV$",
    zeroDecimal: !1
  },
  CZK: {
    code: r.CZK,
    decimalDigits: 2,
    name: "Czech Republic Koruna",
    namePlural: "Czech Republic korunas",
    rounding: 0,
    symbol: "Kč",
    symbolNative: "Kč",
    zeroDecimal: !1
  },
  DJF: {
    code: r.DJF,
    decimalDigits: 0,
    name: "Djiboutian Franc",
    namePlural: "Djiboutian francs",
    rounding: 0,
    symbol: "Fdj",
    symbolNative: "Fdj",
    zeroDecimal: !0
  },
  DKK: {
    code: r.DKK,
    decimalDigits: 2,
    name: "Danish Krone",
    namePlural: "Danish kroner",
    rounding: 0,
    symbol: "Dkr",
    symbolNative: "kr",
    zeroDecimal: !1
  },
  DOP: {
    code: r.DOP,
    decimalDigits: 2,
    name: "Dominican Peso",
    namePlural: "Dominican pesos",
    rounding: 0,
    symbol: "RD$",
    symbolNative: "RD$",
    zeroDecimal: !1
  },
  DZD: {
    code: r.DZD,
    decimalDigits: 2,
    name: "Algerian Dinar",
    namePlural: "Algerian dinars",
    rounding: 0,
    symbol: "DA",
    symbolNative: "د.ج.‏",
    zeroDecimal: !1
  },
  EEK: {
    code: r.EEK,
    decimalDigits: 2,
    deprecated: !0,
    name: "Estonian Kroon",
    namePlural: "Estonian kroons",
    rounding: 0,
    symbol: "Ekr",
    symbolNative: "kr",
    zeroDecimal: !1
  },
  EGP: {
    code: r.EGP,
    decimalDigits: 2,
    name: "Egyptian Pound",
    namePlural: "Egyptian pounds",
    rounding: 0,
    symbol: "EGP",
    symbolNative: "ج.م.‏",
    zeroDecimal: !1
  },
  ERN: {
    code: r.ERN,
    decimalDigits: 2,
    name: "Eritrean Nakfa",
    namePlural: "Eritrean nakfas",
    rounding: 0,
    symbol: "Nfk",
    symbolNative: "Nfk",
    zeroDecimal: !1
  },
  ETB: {
    code: r.ETB,
    decimalDigits: 2,
    name: "Ethiopian Birr",
    namePlural: "Ethiopian birrs",
    rounding: 0,
    symbol: "Br",
    symbolNative: "Br",
    zeroDecimal: !1
  },
  EUR: {
    code: r.EUR,
    decimalDigits: 2,
    name: "Euro",
    namePlural: "euros",
    rounding: 0,
    symbol: "€",
    symbolNative: "€",
    zeroDecimal: !1
  },
  FJD: {
    code: r.FJD,
    decimalDigits: 2,
    name: "Fijian Dollar",
    namePlural: "Fijian dollars",
    rounding: 0,
    symbol: "FJD",
    symbolNative: "$",
    zeroDecimal: !1
  },
  FKP: {
    code: r.FKP,
    decimalDigits: 2,
    name: "Falkland Islands Pound",
    namePlural: "Falkland Islands pounds",
    rounding: 0,
    symbol: "FKP",
    symbolNative: "£",
    zeroDecimal: !1
  },
  GBP: {
    code: r.GBP,
    decimalDigits: 2,
    name: "British Pound Sterling",
    namePlural: "British pounds sterling",
    rounding: 0,
    symbol: "£",
    symbolNative: "£",
    zeroDecimal: !1
  },
  GEL: {
    code: r.GEL,
    decimalDigits: 2,
    name: "Georgian Lari",
    namePlural: "Georgian laris",
    rounding: 0,
    symbol: "GEL",
    symbolNative: "GEL",
    zeroDecimal: !1
  },
  GHS: {
    code: r.GHS,
    decimalDigits: 2,
    name: "Ghanaian Cedi",
    namePlural: "Ghanaian cedis",
    rounding: 0,
    symbol: "GH₵",
    symbolNative: "GH₵",
    zeroDecimal: !1
  },
  GIP: {
    code: r.GIP,
    decimalDigits: 2,
    name: "Gibraltar Pound",
    namePlural: "Gibraltar pounds",
    rounding: 0,
    symbol: "GIP",
    symbolNative: "£",
    zeroDecimal: !1
  },
  GMD: {
    code: r.GMD,
    decimalDigits: 2,
    name: "Gambian Dalasi",
    namePlural: "Gambian dalasis",
    rounding: 0,
    symbol: "GMD",
    symbolNative: "D",
    zeroDecimal: !1
  },
  GNF: {
    code: r.GNF,
    decimalDigits: 0,
    name: "Guinean Franc",
    namePlural: "Guinean francs",
    rounding: 0,
    symbol: "FG",
    symbolNative: "FG",
    zeroDecimal: !0
  },
  GTQ: {
    code: r.GTQ,
    decimalDigits: 2,
    name: "Guatemalan Quetzal",
    namePlural: "Guatemalan quetzals",
    rounding: 0,
    symbol: "GTQ",
    symbolNative: "Q",
    zeroDecimal: !1
  },
  GYD: {
    code: r.GYD,
    decimalDigits: 0,
    name: "Guyanaese Dollar",
    namePlural: "Guyanaese dollars",
    rounding: 0,
    symbol: "GYD",
    symbolNative: "$",
    zeroDecimal: !1
  },
  HKD: {
    code: r.HKD,
    decimalDigits: 2,
    name: "Hong Kong Dollar",
    namePlural: "Hong Kong dollars",
    rounding: 0,
    symbol: "HK$",
    symbolNative: "$",
    zeroDecimal: !1
  },
  HNL: {
    code: r.HNL,
    decimalDigits: 2,
    name: "Honduran Lempira",
    namePlural: "Honduran lempiras",
    rounding: 0,
    symbol: "HNL",
    symbolNative: "L",
    zeroDecimal: !1
  },
  HRK: {
    code: r.HRK,
    decimalDigits: 2,
    deprecated: !0,
    name: "Croatian Kuna",
    namePlural: "Croatian kunas",
    rounding: 0,
    symbol: "kn",
    symbolNative: "kn",
    zeroDecimal: !1
  },
  HTG: {
    code: r.HTG,
    decimalDigits: 2,
    name: "Haitian Gourde",
    namePlural: "Haitian gourdes",
    rounding: 0,
    symbol: "HTG",
    symbolNative: "G",
    zeroDecimal: !1
  },
  HUF: {
    code: r.HUF,
    decimalDigits: 0,
    name: "Hungarian Forint",
    namePlural: "Hungarian forints",
    rounding: 0,
    symbol: "Ft",
    symbolNative: "Ft",
    zeroDecimal: !1
  },
  IDR: {
    code: r.IDR,
    decimalDigits: 0,
    name: "Indonesian Rupiah",
    namePlural: "Indonesian rupiahs",
    rounding: 0,
    symbol: "Rp",
    symbolNative: "Rp",
    zeroDecimal: !1
  },
  ILS: {
    code: r.ILS,
    decimalDigits: 2,
    name: "Israeli New Sheqel",
    namePlural: "Israeli new sheqels",
    rounding: 0,
    symbol: "₪",
    symbolNative: "₪",
    zeroDecimal: !1
  },
  INR: {
    code: r.INR,
    decimalDigits: 2,
    name: "Indian Rupee",
    namePlural: "Indian rupees",
    rounding: 0,
    symbol: "Rs",
    symbolNative: "টকা",
    zeroDecimal: !1
  },
  IQD: {
    code: r.IQD,
    decimalDigits: 0,
    name: "Iraqi Dinar",
    namePlural: "Iraqi dinars",
    rounding: 0,
    symbol: "IQD",
    symbolNative: "د.ع.‏",
    zeroDecimal: !1
  },
  IRR: {
    code: r.IRR,
    decimalDigits: 0,
    name: "Iranian Rial",
    namePlural: "Iranian rials",
    rounding: 0,
    symbol: "IRR",
    symbolNative: "﷼",
    zeroDecimal: !0
  },
  ISK: {
    code: r.ISK,
    decimalDigits: 0,
    name: "Icelandic Króna",
    namePlural: "Icelandic krónur",
    rounding: 0,
    symbol: "Ikr",
    symbolNative: "kr",
    zeroDecimal: !1
  },
  JMD: {
    code: r.JMD,
    decimalDigits: 2,
    name: "Jamaican Dollar",
    namePlural: "Jamaican dollars",
    rounding: 0,
    symbol: "J$",
    symbolNative: "$",
    zeroDecimal: !1
  },
  JOD: {
    code: r.JOD,
    decimalDigits: 3,
    name: "Jordanian Dinar",
    namePlural: "Jordanian dinars",
    rounding: 0,
    symbol: "JD",
    symbolNative: "د.أ.‏",
    zeroDecimal: !1
  },
  JPY: {
    code: r.JPY,
    decimalDigits: 0,
    name: "Japanese Yen",
    namePlural: "Japanese yen",
    rounding: 0,
    symbol: "¥",
    symbolNative: "￥",
    zeroDecimal: !0
  },
  KES: {
    code: r.KES,
    decimalDigits: 2,
    name: "Kenyan Shilling",
    namePlural: "Kenyan shillings",
    rounding: 0,
    symbol: "Ksh",
    symbolNative: "Ksh",
    zeroDecimal: !1
  },
  KGS: {
    code: r.KGS,
    decimalDigits: 2,
    name: "Kyrgystani Som",
    namePlural: "Kyrgystani soms",
    rounding: 0,
    symbol: "KGS",
    symbolNative: "сом",
    zeroDecimal: !1
  },
  KHR: {
    code: r.KHR,
    decimalDigits: 2,
    name: "Cambodian Riel",
    namePlural: "Cambodian riels",
    rounding: 0,
    symbol: "KHR",
    symbolNative: "៛",
    zeroDecimal: !1
  },
  KMF: {
    code: r.KMF,
    decimalDigits: 0,
    name: "Comorian Franc",
    namePlural: "Comorian francs",
    rounding: 0,
    symbol: "CF",
    symbolNative: "FC",
    zeroDecimal: !0
  },
  KPW: {
    code: r.KPW,
    decimalDigits: 0,
    name: "North Korean Won",
    namePlural: "North Korean won",
    rounding: 0,
    symbol: "KPW",
    symbolNative: "KPW",
    zeroDecimal: !1
  },
  KRW: {
    code: r.KRW,
    decimalDigits: 0,
    name: "South Korean Won",
    namePlural: "South Korean won",
    rounding: 0,
    symbol: "₩",
    symbolNative: "₩",
    zeroDecimal: !0
  },
  KWD: {
    code: r.KWD,
    decimalDigits: 3,
    name: "Kuwaiti Dinar",
    namePlural: "Kuwaiti dinars",
    rounding: 0,
    symbol: "KD",
    symbolNative: "د.ك.‏",
    zeroDecimal: !1
  },
  KYD: {
    code: r.KYD,
    decimalDigits: 2,
    name: "Cayman Islands Dollar",
    namePlural: "Cayman Islands dollars",
    rounding: 0,
    symbol: "KYD",
    symbolNative: "$",
    zeroDecimal: !1
  },
  KZT: {
    code: r.KZT,
    decimalDigits: 2,
    name: "Kazakhstani Tenge",
    namePlural: "Kazakhstani tenges",
    rounding: 0,
    symbol: "KZT",
    symbolNative: "тңг.",
    zeroDecimal: !1
  },
  LAK: {
    code: r.LAK,
    decimalDigits: 0,
    name: "Laotian Kip",
    namePlural: "Laotian kips",
    rounding: 0,
    symbol: "LAK",
    symbolNative: "₭",
    zeroDecimal: !1
  },
  LBP: {
    code: r.LBP,
    decimalDigits: 0,
    name: "Lebanese Pound",
    namePlural: "Lebanese pounds",
    rounding: 0,
    symbol: "LB£",
    symbolNative: "ل.ل.‏",
    zeroDecimal: !1
  },
  LKR: {
    code: r.LKR,
    decimalDigits: 2,
    name: "Sri Lankan Rupee",
    namePlural: "Sri Lankan rupees",
    rounding: 0,
    symbol: "SLRs",
    symbolNative: "SL Re",
    zeroDecimal: !1
  },
  LRD: {
    code: r.LRD,
    decimalDigits: 2,
    name: "Liberian Dollar",
    namePlural: "Liberian dollars",
    rounding: 0,
    symbol: "LRD",
    symbolNative: "$",
    zeroDecimal: !1
  },
  LSL: {
    code: r.LSL,
    decimalDigits: 2,
    name: "Lesotho Loti",
    namePlural: "Lesotho lotis",
    rounding: 0,
    symbol: "LSL",
    symbolNative: "LSL",
    zeroDecimal: !1
  },
  LTL: {
    code: r.LTL,
    decimalDigits: 2,
    deprecated: !0,
    name: "Lithuanian Litas",
    namePlural: "Lithuanian litai",
    rounding: 0,
    symbol: "Lt",
    symbolNative: "Lt",
    zeroDecimal: !1
  },
  LVL: {
    code: r.LVL,
    decimalDigits: 2,
    deprecated: !0,
    name: "Latvian Lats",
    namePlural: "Latvian lati",
    rounding: 0,
    symbol: "Ls",
    symbolNative: "Ls",
    zeroDecimal: !1
  },
  LYD: {
    code: r.LYD,
    decimalDigits: 3,
    name: "Libyan Dinar",
    namePlural: "Libyan dinars",
    rounding: 0,
    symbol: "LD",
    symbolNative: "د.ل.‏",
    zeroDecimal: !1
  },
  MAD: {
    code: r.MAD,
    decimalDigits: 2,
    name: "Moroccan Dirham",
    namePlural: "Moroccan dirhams",
    rounding: 0,
    symbol: "MAD",
    symbolNative: "د.م.‏",
    zeroDecimal: !1
  },
  MDL: {
    code: r.MDL,
    decimalDigits: 2,
    name: "Moldovan Leu",
    namePlural: "Moldovan lei",
    rounding: 0,
    symbol: "MDL",
    symbolNative: "MDL",
    zeroDecimal: !1
  },
  MGA: {
    code: r.MGA,
    decimalDigits: 0,
    name: "Malagasy Ariary",
    namePlural: "Malagasy Ariaries",
    rounding: 0,
    symbol: "MGA",
    symbolNative: "MGA",
    zeroDecimal: !0
  },
  MKD: {
    code: r.MKD,
    decimalDigits: 2,
    name: "Macedonian Denar",
    namePlural: "Macedonian denari",
    rounding: 0,
    symbol: "MKD",
    symbolNative: "MKD",
    zeroDecimal: !1
  },
  MMK: {
    code: r.MMK,
    decimalDigits: 0,
    name: "Myanma Kyat",
    namePlural: "Myanma kyats",
    rounding: 0,
    symbol: "MMK",
    symbolNative: "K",
    zeroDecimal: !1
  },
  MNT: {
    code: r.MNT,
    decimalDigits: 0,
    name: "Mongolian Tugrik",
    namePlural: "Mongolian tugriks",
    rounding: 0,
    symbol: "MNT",
    symbolNative: "₮",
    zeroDecimal: !1
  },
  MOP: {
    code: r.MOP,
    decimalDigits: 2,
    name: "Macanese Pataca",
    namePlural: "Macanese patacas",
    rounding: 0,
    symbol: "MOP$",
    symbolNative: "MOP$",
    zeroDecimal: !1
  },
  MRO: {
    code: r.MRO,
    decimalDigits: 0,
    deprecated: !0,
    name: "Mauritanian Ouguiya",
    namePlural: "Mauritanian ouguiyas",
    rounding: 0,
    symbol: "MRO",
    symbolNative: "أ.م.‏",
    zeroDecimal: !1
  },
  MRU: {
    code: r.MRU,
    decimalDigits: 0,
    name: "Mauritanian Ouguiya",
    namePlural: "Mauritanian ouguiyas",
    rounding: 0,
    symbol: "MRU",
    symbolNative: "أ.م.‏",
    zeroDecimal: !1
  },
  MUR: {
    code: r.MUR,
    decimalDigits: 0,
    name: "Mauritian Rupee",
    namePlural: "Mauritian rupees",
    rounding: 0,
    symbol: "MURs",
    symbolNative: "MURs",
    zeroDecimal: !1
  },
  MVR: {
    code: r.MVR,
    decimalDigits: 0,
    name: "Maldivian rufiyaa",
    namePlural: "Maldivian rufiyaa",
    rounding: 0,
    symbol: "MVR",
    symbolNative: "Rf",
    zeroDecimal: !1
  },
  MWK: {
    code: r.MWK,
    decimalDigits: 2,
    name: "Malawian Kwacha",
    namePlural: "Malawian kwachas",
    rounding: 0,
    symbol: "MWK",
    symbolNative: "MK",
    zeroDecimal: !1
  },
  MXN: {
    code: r.MXN,
    decimalDigits: 2,
    name: "Mexican Peso",
    namePlural: "Mexican pesos",
    rounding: 0,
    symbol: "MX$",
    symbolNative: "$",
    zeroDecimal: !1
  },
  MYR: {
    code: r.MYR,
    decimalDigits: 2,
    name: "Malaysian Ringgit",
    namePlural: "Malaysian ringgits",
    rounding: 0,
    symbol: "RM",
    symbolNative: "RM",
    zeroDecimal: !1
  },
  MZN: {
    code: r.MZN,
    decimalDigits: 2,
    name: "Mozambican Metical",
    namePlural: "Mozambican meticals",
    rounding: 0,
    symbol: "MTn",
    symbolNative: "MTn",
    zeroDecimal: !1
  },
  NAD: {
    code: r.NAD,
    decimalDigits: 2,
    name: "Namibian Dollar",
    namePlural: "Namibian dollars",
    rounding: 0,
    symbol: "N$",
    symbolNative: "N$",
    zeroDecimal: !1
  },
  NGN: {
    code: r.NGN,
    decimalDigits: 2,
    name: "Nigerian Naira",
    namePlural: "Nigerian nairas",
    rounding: 0,
    symbol: "₦",
    symbolNative: "₦",
    zeroDecimal: !1
  },
  NIO: {
    code: r.NIO,
    decimalDigits: 2,
    name: "Nicaraguan Córdoba",
    namePlural: "Nicaraguan córdobas",
    rounding: 0,
    symbol: "C$",
    symbolNative: "C$",
    zeroDecimal: !1
  },
  NOK: {
    code: r.NOK,
    decimalDigits: 2,
    name: "Norwegian Krone",
    namePlural: "Norwegian kroner",
    rounding: 0,
    symbol: "Nkr",
    symbolNative: "kr",
    zeroDecimal: !1
  },
  NPR: {
    code: r.NPR,
    decimalDigits: 2,
    name: "Nepalese Rupee",
    namePlural: "Nepalese rupees",
    rounding: 0,
    symbol: "NPRs",
    symbolNative: "नेरू",
    zeroDecimal: !1
  },
  NZD: {
    code: r.NZD,
    decimalDigits: 2,
    name: "New Zealand Dollar",
    namePlural: "New Zealand dollars",
    rounding: 0,
    symbol: "NZ$",
    symbolNative: "$",
    zeroDecimal: !1
  },
  OMR: {
    code: r.OMR,
    decimalDigits: 3,
    name: "Omani Rial",
    namePlural: "Omani rials",
    rounding: 0,
    symbol: "OMR",
    symbolNative: "ر.ع.‏",
    zeroDecimal: !1
  },
  PAB: {
    code: r.PAB,
    decimalDigits: 2,
    name: "Panamanian Balboa",
    namePlural: "Panamanian balboas",
    rounding: 0,
    symbol: "B/.",
    symbolNative: "B/.",
    zeroDecimal: !1
  },
  PEN: {
    code: r.PEN,
    decimalDigits: 2,
    name: "Peruvian Nuevo Sol",
    namePlural: "Peruvian nuevos soles",
    rounding: 0,
    symbol: "S/.",
    symbolNative: "S/.",
    zeroDecimal: !1
  },
  PGK: {
    code: r.PGK,
    decimalDigits: 2,
    name: "Papua New Guinean Kina",
    namePlural: "Papua New Guinean kina",
    rounding: 0,
    symbol: "PGK",
    symbolNative: "K",
    zeroDecimal: !1
  },
  PHP: {
    code: r.PHP,
    decimalDigits: 2,
    name: "Philippine Peso",
    namePlural: "Philippine pesos",
    rounding: 0,
    symbol: "₱",
    symbolNative: "₱",
    zeroDecimal: !1
  },
  PKR: {
    code: r.PKR,
    decimalDigits: 0,
    name: "Pakistani Rupee",
    namePlural: "Pakistani rupees",
    rounding: 0,
    symbol: "PKRs",
    symbolNative: "₨",
    zeroDecimal: !1
  },
  PLN: {
    code: r.PLN,
    decimalDigits: 2,
    name: "Polish Zloty",
    namePlural: "Polish zlotys",
    rounding: 0,
    symbol: "zł",
    symbolNative: "zł",
    zeroDecimal: !1
  },
  PYG: {
    code: r.PYG,
    decimalDigits: 0,
    name: "Paraguayan Guarani",
    namePlural: "Paraguayan guaranis",
    rounding: 0,
    symbol: "₲",
    symbolNative: "₲",
    zeroDecimal: !0
  },
  QAR: {
    code: r.QAR,
    decimalDigits: 2,
    name: "Qatari Rial",
    namePlural: "Qatari rials",
    rounding: 0,
    symbol: "QR",
    symbolNative: "ر.ق.‏",
    zeroDecimal: !1
  },
  RON: {
    code: r.RON,
    decimalDigits: 2,
    name: "Romanian Leu",
    namePlural: "Romanian lei",
    rounding: 0,
    symbol: "RON",
    symbolNative: "RON",
    zeroDecimal: !1
  },
  RSD: {
    code: r.RSD,
    decimalDigits: 0,
    name: "Serbian Dinar",
    namePlural: "Serbian dinars",
    rounding: 0,
    symbol: "din.",
    symbolNative: "дин.",
    zeroDecimal: !1
  },
  RUB: {
    code: r.RUB,
    decimalDigits: 2,
    name: "Russian Ruble",
    namePlural: "Russian rubles",
    rounding: 0,
    symbol: "RUB",
    symbolNative: "₽.",
    zeroDecimal: !1
  },
  RWF: {
    code: r.RWF,
    decimalDigits: 0,
    name: "Rwandan Franc",
    namePlural: "Rwandan francs",
    rounding: 0,
    symbol: "RWF",
    symbolNative: "FR",
    zeroDecimal: !0
  },
  SAR: {
    code: r.SAR,
    decimalDigits: 2,
    name: "Saudi Riyal",
    namePlural: "Saudi riyals",
    rounding: 0,
    symbol: "SR",
    symbolNative: "ر.س.‏",
    zeroDecimal: !1
  },
  SBD: {
    code: r.SBD,
    decimalDigits: 2,
    name: "Solomon Islands Dollar",
    namePlural: "Solomon Islands dollars",
    rounding: 0,
    symbol: "SBD",
    symbolNative: "$",
    zeroDecimal: !1
  },
  SCR: {
    code: r.SCR,
    decimalDigits: 2,
    name: "Seychellois Rupee",
    namePlural: "Seychellois rupees",
    rounding: 0,
    symbol: "SCR",
    symbolNative: "SR",
    zeroDecimal: !1
  },
  SDG: {
    code: r.SDG,
    decimalDigits: 2,
    name: "Sudanese Pound",
    namePlural: "Sudanese pounds",
    rounding: 0,
    symbol: "SDG",
    symbolNative: "SDG",
    zeroDecimal: !1
  },
  SEK: {
    code: r.SEK,
    decimalDigits: 2,
    name: "Swedish Krona",
    namePlural: "Swedish kronor",
    rounding: 0,
    symbol: "Skr",
    symbolNative: "kr",
    zeroDecimal: !1
  },
  SGD: {
    code: r.SGD,
    decimalDigits: 2,
    name: "Singapore Dollar",
    namePlural: "Singapore dollars",
    rounding: 0,
    symbol: "S$",
    symbolNative: "$",
    zeroDecimal: !1
  },
  SHP: {
    code: r.SHP,
    decimalDigits: 2,
    name: "St. Helena Pound",
    namePlural: "St. Helena pounds",
    rounding: 0,
    symbol: "SHP",
    symbolNative: "£",
    zeroDecimal: !1
  },
  SLL: {
    code: r.SLL,
    decimalDigits: 0,
    name: "Sierra Leonean Leone",
    namePlural: "Sierra Leonean leones",
    rounding: 0,
    symbol: "SLL",
    symbolNative: "Le",
    zeroDecimal: !1
  },
  SOS: {
    code: r.SOS,
    decimalDigits: 0,
    name: "Somali Shilling",
    namePlural: "Somali shillings",
    rounding: 0,
    symbol: "Ssh",
    symbolNative: "Ssh",
    zeroDecimal: !1
  },
  SRD: {
    code: r.SRD,
    decimalDigits: 2,
    name: "Surinamese Dollar",
    namePlural: "Surinamese dollars",
    rounding: 0,
    symbol: "SRD",
    symbolNative: "$",
    zeroDecimal: !1
  },
  SSP: {
    code: r.SSP,
    decimalDigits: 2,
    deprecated: !0,
    name: "South Sudanese Pound",
    namePlural: "South Sudanese pounds",
    rounding: 0,
    symbol: "SSP",
    symbolNative: "SSP",
    zeroDecimal: !1
  },
  STD: {
    code: r.STD,
    decimalDigits: 2,
    name: "Dobra",
    namePlural: "Dobras",
    rounding: 0,
    symbol: "Db",
    symbolNative: "Db",
    zeroDecimal: !1
  },
  SYP: {
    code: r.SYP,
    decimalDigits: 0,
    name: "Syrian Pound",
    namePlural: "Syrian pounds",
    rounding: 0,
    symbol: "SY£",
    symbolNative: "ل.س.‏",
    zeroDecimal: !1
  },
  SZL: {
    code: r.SZL,
    decimalDigits: 2,
    name: "Swazi Lilangeni",
    namePlural: "Swazi emalangeni",
    rounding: 0,
    symbol: "SZL",
    symbolNative: "E",
    zeroDecimal: !1
  },
  THB: {
    code: r.THB,
    decimalDigits: 2,
    name: "Thai Baht",
    namePlural: "Thai baht",
    rounding: 0,
    symbol: "฿",
    symbolNative: "฿",
    zeroDecimal: !1
  },
  TJS: {
    code: r.TJS,
    decimalDigits: 2,
    name: "Tajikistani Somoni",
    namePlural: "Tajikistani somonis",
    rounding: 0,
    symbol: "TJS",
    symbolNative: "сом.",
    zeroDecimal: !1
  },
  TMT: {
    code: r.TMT,
    decimalDigits: 2,
    name: "Turkmenistan Manat",
    namePlural: "Turkmenistan manats",
    rounding: 0,
    symbol: "TMT",
    symbolNative: "TMT",
    zeroDecimal: !1
  },
  TND: {
    code: r.TND,
    decimalDigits: 3,
    name: "Tunisian Dinar",
    namePlural: "Tunisian dinars",
    rounding: 0,
    symbol: "DT",
    symbolNative: "د.ت.‏",
    zeroDecimal: !1
  },
  TOP: {
    code: r.TOP,
    decimalDigits: 2,
    name: "Tongan Paʻanga",
    namePlural: "Tongan paʻanga",
    rounding: 0,
    symbol: "T$",
    symbolNative: "T$",
    zeroDecimal: !1
  },
  TRY: {
    code: r.TRY,
    decimalDigits: 2,
    name: "Turkish Lira",
    namePlural: "Turkish Lira",
    rounding: 0,
    symbol: "TL",
    symbolNative: "TL",
    zeroDecimal: !1
  },
  TTD: {
    code: r.TTD,
    decimalDigits: 2,
    name: "Trinidad and Tobago Dollar",
    namePlural: "Trinidad and Tobago dollars",
    rounding: 0,
    symbol: "TT$",
    symbolNative: "$",
    zeroDecimal: !1
  },
  TWD: {
    code: r.TWD,
    decimalDigits: 2,
    name: "New Taiwan Dollar",
    namePlural: "New Taiwan dollars",
    rounding: 0,
    symbol: "NT$",
    symbolNative: "NT$",
    zeroDecimal: !1
  },
  TZS: {
    code: r.TZS,
    decimalDigits: 0,
    name: "Tanzanian Shilling",
    namePlural: "Tanzanian shillings",
    rounding: 0,
    symbol: "TSh",
    symbolNative: "TSh",
    zeroDecimal: !1
  },
  UAH: {
    code: r.UAH,
    decimalDigits: 2,
    name: "Ukrainian Hryvnia",
    namePlural: "Ukrainian hryvnias",
    rounding: 0,
    symbol: "₴",
    symbolNative: "₴",
    zeroDecimal: !1
  },
  UGX: {
    code: r.UGX,
    decimalDigits: 0,
    name: "Ugandan Shilling",
    namePlural: "Ugandan shillings",
    rounding: 0,
    symbol: "USh",
    symbolNative: "USh",
    zeroDecimal: !0
  },
  USD: {
    code: r.USD,
    decimalDigits: 2,
    name: "US Dollar",
    namePlural: "US dollars",
    rounding: 0,
    symbol: "$",
    symbolNative: "$",
    zeroDecimal: !1
  },
  UYU: {
    code: r.UYU,
    decimalDigits: 2,
    name: "Uruguayan Peso",
    namePlural: "Uruguayan pesos",
    rounding: 0,
    symbol: "$U",
    symbolNative: "$",
    zeroDecimal: !1
  },
  UZS: {
    code: r.UZS,
    decimalDigits: 0,
    name: "Uzbekistan Som",
    namePlural: "Uzbekistan som",
    rounding: 0,
    symbol: "UZS",
    symbolNative: "UZS",
    zeroDecimal: !1
  },
  VEF: {
    code: r.VEF,
    decimalDigits: 2,
    deprecated: !0,
    name: "Venezuelan Bolívar",
    namePlural: "Venezuelan bolívars",
    rounding: 0,
    symbol: "Bs.F.",
    symbolNative: "Bs.F.",
    zeroDecimal: !1
  },
  VES: {
    code: r.VES,
    decimalDigits: 2,
    name: "Venezuelan Bolívar",
    namePlural: "Venezuelan bolívars",
    rounding: 0,
    symbol: "Bs.F.",
    symbolNative: "Bs.F.",
    zeroDecimal: !1
  },
  VND: {
    code: r.VND,
    decimalDigits: 0,
    name: "Vietnamese Dong",
    namePlural: "Vietnamese dong",
    rounding: 0,
    symbol: "₫",
    symbolNative: "₫",
    zeroDecimal: !0
  },
  VUV: {
    code: r.VUV,
    decimalDigits: 0,
    name: "Vanuatu Vatu",
    namePlural: "Vanuatu vatus",
    rounding: 0,
    symbol: "VUV",
    symbolNative: "VT",
    zeroDecimal: !0
  },
  WST: {
    code: r.WST,
    decimalDigits: 2,
    name: "Samoan Tala",
    namePlural: "Samoan tala",
    rounding: 0,
    symbol: "WST",
    symbolNative: "WS$",
    zeroDecimal: !1
  },
  XAF: {
    code: r.XAF,
    decimalDigits: 0,
    name: "CFA Franc BEAC",
    namePlural: "CFA francs BEAC",
    rounding: 0,
    symbol: "FCFA",
    symbolNative: "FCFA",
    zeroDecimal: !0
  },
  XCD: {
    code: r.XCD,
    decimalDigits: 2,
    name: "East Caribbean Dollar",
    namePlural: "East Caribbean dollars",
    rounding: 0,
    symbol: "EC$",
    symbolNative: "$",
    zeroDecimal: !1
  },
  XOF: {
    code: r.XOF,
    decimalDigits: 0,
    name: "CFA Franc BCEAO",
    namePlural: "CFA francs BCEAO",
    rounding: 0,
    symbol: "CFA",
    symbolNative: "CFA",
    zeroDecimal: !0
  },
  XPF: {
    code: r.XPF,
    decimalDigits: 0,
    name: "CFP Franc",
    namePlural: "CFP francs",
    rounding: 0,
    symbol: "CFPF",
    symbolNative: "FCFP",
    zeroDecimal: !0
  },
  YER: {
    code: r.YER,
    decimalDigits: 0,
    name: "Yemeni Rial",
    namePlural: "Yemeni rials",
    rounding: 0,
    symbol: "YR",
    symbolNative: "ر.ي.‏",
    zeroDecimal: !1
  },
  ZAR: {
    code: r.ZAR,
    decimalDigits: 2,
    name: "South African Rand",
    namePlural: "South African rand",
    rounding: 0,
    symbol: "R",
    symbolNative: "R",
    zeroDecimal: !1
  },
  ZMK: {
    code: r.ZMK,
    decimalDigits: 0,
    name: "Zambian Kwacha",
    namePlural: "Zambian kwachas",
    rounding: 0,
    symbol: "ZK",
    symbolNative: "ZK",
    zeroDecimal: !0
  },
  ZMW: {
    code: r.ZMW,
    decimalDigits: 2,
    name: "Zambian Kwacha",
    namePlural: "Zambian kwachas",
    rounding: 0,
    symbol: "ZMW",
    symbolNative: "K",
    zeroDecimal: !1
  },
  ZWL: {
    code: r.ZWL,
    decimalDigits: 0,
    name: "Zimbabwean Dollar",
    namePlural: "Zimbabwean Dollar",
    rounding: 0,
    symbol: "ZWL$",
    symbolNative: "ZWL$",
    zeroDecimal: !0
  }
}, qr = [
  r.AED,
  r.AFN,
  r.ALL,
  r.AMD,
  r.ANG,
  r.AOA,
  r.ARS,
  r.AUD,
  r.AWG,
  r.AZN,
  r.BAM,
  r.BBD,
  r.BDT,
  r.BHD,
  r.BGN,
  r.BIF,
  r.BMD,
  r.BND,
  r.BOB,
  r.BRL,
  r.BSD,
  r.BWP,
  r.BZD,
  r.CAD,
  r.CDF,
  r.CHF,
  r.CLP,
  r.CNY,
  r.COP,
  r.CRC,
  r.CVE,
  r.CZK,
  r.DJF,
  r.DKK,
  r.DOP,
  r.DZD,
  r.EGP,
  r.ETB,
  r.EUR,
  r.FJD,
  r.FKP,
  r.GBP,
  r.GEL,
  r.GIP,
  r.GMD,
  r.GNF,
  r.GTQ,
  r.GYD,
  r.HKD,
  r.HNL,
  r.HTG,
  r.HUF,
  r.IDR,
  r.ILS,
  r.INR,
  r.ISK,
  r.JMD,
  r.JOD,
  r.JPY,
  r.KES,
  r.KGS,
  r.KHR,
  r.KMF,
  r.KRW,
  r.KWD,
  r.KYD,
  r.KZT,
  r.LAK,
  r.LBP,
  r.LKR,
  r.LRD,
  r.LSL,
  r.MAD,
  r.MDL,
  r.MGA,
  r.MKD,
  r.MMK,
  r.MNT,
  r.MOP,
  r.MRU,
  r.MUR,
  r.MVR,
  r.MWK,
  r.MXN,
  r.MYR,
  r.MZN,
  r.NAD,
  r.NGN,
  r.NIO,
  r.NOK,
  r.NPR,
  r.NZD,
  r.OMR,
  r.PAB,
  r.PEN,
  r.PGK,
  r.PHP,
  r.PKR,
  r.PLN,
  r.PYG,
  r.QAR,
  r.RON,
  r.RSD,
  r.RUB,
  r.RWF,
  r.SAR,
  r.SBD,
  r.SCR,
  r.SEK,
  r.SGD,
  r.SHP,
  r.SLL,
  r.SOS,
  r.SRD,
  r.STD,
  r.SZL,
  r.THB,
  r.TJS,
  r.TND,
  r.TOP,
  r.TRY,
  r.TTD,
  r.TWD,
  r.TZS,
  r.UAH,
  r.USD,
  r.UYU,
  r.UZS,
  r.VND,
  r.VUV,
  r.WST,
  r.XAF,
  r.XCD,
  r.XOF,
  r.XPF,
  r.YER,
  r.ZAR,
  r.ZMW
];
Object.values(ea).filter((e) => !e.deprecated).map((e) => e.code);
const Jr = Wr(ea, qr);
Object.values(ea).filter(
  (e) => e.zeroDecimal && e.code in Jr
).map((e) => e.code);
var Se = { exports: {} }, Xr = Se.exports, Pa;
function mt() {
  return Pa || (Pa = 1, (function(e, a) {
    (function(t, n) {
      e.exports = n();
    })(Xr, (function() {
      var t = 1e3, n = 6e4, i = 36e5, s = "millisecond", o = "second", l = "minute", u = "hour", m = "day", D = "week", h = "month", p = "quarter", y = "year", v = "date", c = "Invalid Date", R = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, E = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, T = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(S) {
        var g = ["th", "st", "nd", "rd"], d = S % 100;
        return "[" + S + (g[(d - 20) % 10] || g[d] || g[0]) + "]";
      } }, O = function(S, g, d) {
        var b = String(S);
        return !b || b.length >= g ? S : "" + Array(g + 1 - b.length).join(d) + S;
      }, F = { s: O, z: function(S) {
        var g = -S.utcOffset(), d = Math.abs(g), b = Math.floor(d / 60), f = d % 60;
        return (g <= 0 ? "+" : "-") + O(b, 2, "0") + ":" + O(f, 2, "0");
      }, m: function S(g, d) {
        if (g.date() < d.date()) return -S(d, g);
        var b = 12 * (d.year() - g.year()) + (d.month() - g.month()), f = g.clone().add(b, h), P = d - f < 0, N = g.clone().add(b + (P ? -1 : 1), h);
        return +(-(b + (d - f) / (P ? f - N : N - f)) || 0);
      }, a: function(S) {
        return S < 0 ? Math.ceil(S) || 0 : Math.floor(S);
      }, p: function(S) {
        return { M: h, y, w: D, d: m, D: v, h: u, m: l, s: o, ms: s, Q: p }[S] || String(S || "").toLowerCase().replace(/s$/, "");
      }, u: function(S) {
        return S === void 0;
      } }, A = "en", _ = {};
      _[A] = T;
      var U = "$isDayjsObject", j = function(S) {
        return S instanceof pe || !(!S || !S[U]);
      }, Y = function S(g, d, b) {
        var f;
        if (!g) return A;
        if (typeof g == "string") {
          var P = g.toLowerCase();
          _[P] && (f = P), d && (_[P] = d, f = P);
          var N = g.split("-");
          if (!f && N.length > 1) return S(N[0]);
        } else {
          var L = g.name;
          _[L] = g, f = L;
        }
        return !b && f && (A = f), f || !b && A;
      }, $ = function(S, g) {
        if (j(S)) return S.clone();
        var d = typeof g == "object" ? g : {};
        return d.date = S, d.args = arguments, new pe(d);
      }, M = F;
      M.l = Y, M.i = j, M.w = function(S, g) {
        return $(S, { locale: g.$L, utc: g.$u, x: g.$x, $offset: g.$offset });
      };
      var pe = (function() {
        function S(d) {
          this.$L = Y(d.locale, null, !0), this.parse(d), this.$x = this.$x || d.x || {}, this[U] = !0;
        }
        var g = S.prototype;
        return g.parse = function(d) {
          this.$d = (function(b) {
            var f = b.date, P = b.utc;
            if (f === null) return /* @__PURE__ */ new Date(NaN);
            if (M.u(f)) return /* @__PURE__ */ new Date();
            if (f instanceof Date) return new Date(f);
            if (typeof f == "string" && !/Z$/i.test(f)) {
              var N = f.match(R);
              if (N) {
                var L = N[2] - 1 || 0, K = (N[7] || "0").substring(0, 3);
                return P ? new Date(Date.UTC(N[1], L, N[3] || 1, N[4] || 0, N[5] || 0, N[6] || 0, K)) : new Date(N[1], L, N[3] || 1, N[4] || 0, N[5] || 0, N[6] || 0, K);
              }
            }
            return new Date(f);
          })(d), this.init();
        }, g.init = function() {
          var d = this.$d;
          this.$y = d.getFullYear(), this.$M = d.getMonth(), this.$D = d.getDate(), this.$W = d.getDay(), this.$H = d.getHours(), this.$m = d.getMinutes(), this.$s = d.getSeconds(), this.$ms = d.getMilliseconds();
        }, g.$utils = function() {
          return M;
        }, g.isValid = function() {
          return this.$d.toString() !== c;
        }, g.isSame = function(d, b) {
          var f = $(d);
          return this.startOf(b) <= f && f <= this.endOf(b);
        }, g.isAfter = function(d, b) {
          return $(d) < this.startOf(b);
        }, g.isBefore = function(d, b) {
          return this.endOf(b) < $(d);
        }, g.$g = function(d, b, f) {
          return M.u(d) ? this[b] : this.set(f, d);
        }, g.unix = function() {
          return Math.floor(this.valueOf() / 1e3);
        }, g.valueOf = function() {
          return this.$d.getTime();
        }, g.startOf = function(d, b) {
          var f = this, P = !!M.u(b) || b, N = M.p(d), L = function(ne, k) {
            var Q = M.w(f.$u ? Date.UTC(f.$y, k, ne) : new Date(f.$y, k, ne), f);
            return P ? Q : Q.endOf(m);
          }, K = function(ne, k) {
            return M.w(f.toDate()[ne].apply(f.toDate("s"), (P ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(k)), f);
          }, H = this.$W, G = this.$M, x = this.$D, ce = "set" + (this.$u ? "UTC" : "");
          switch (N) {
            case y:
              return P ? L(1, 0) : L(31, 11);
            case h:
              return P ? L(1, G) : L(0, G + 1);
            case D:
              var re = this.$locale().weekStart || 0, de = (H < re ? H + 7 : H) - re;
              return L(P ? x - de : x + (6 - de), G);
            case m:
            case v:
              return K(ce + "Hours", 0);
            case u:
              return K(ce + "Minutes", 1);
            case l:
              return K(ce + "Seconds", 2);
            case o:
              return K(ce + "Milliseconds", 3);
            default:
              return this.clone();
          }
        }, g.endOf = function(d) {
          return this.startOf(d, !1);
        }, g.$set = function(d, b) {
          var f, P = M.p(d), N = "set" + (this.$u ? "UTC" : ""), L = (f = {}, f[m] = N + "Date", f[v] = N + "Date", f[h] = N + "Month", f[y] = N + "FullYear", f[u] = N + "Hours", f[l] = N + "Minutes", f[o] = N + "Seconds", f[s] = N + "Milliseconds", f)[P], K = P === m ? this.$D + (b - this.$W) : b;
          if (P === h || P === y) {
            var H = this.clone().set(v, 1);
            H.$d[L](K), H.init(), this.$d = H.set(v, Math.min(this.$D, H.daysInMonth())).$d;
          } else L && this.$d[L](K);
          return this.init(), this;
        }, g.set = function(d, b) {
          return this.clone().$set(d, b);
        }, g.get = function(d) {
          return this[M.p(d)]();
        }, g.add = function(d, b) {
          var f, P = this;
          d = Number(d);
          var N = M.p(b), L = function(G) {
            var x = $(P);
            return M.w(x.date(x.date() + Math.round(G * d)), P);
          };
          if (N === h) return this.set(h, this.$M + d);
          if (N === y) return this.set(y, this.$y + d);
          if (N === m) return L(1);
          if (N === D) return L(7);
          var K = (f = {}, f[l] = n, f[u] = i, f[o] = t, f)[N] || 1, H = this.$d.getTime() + d * K;
          return M.w(H, this);
        }, g.subtract = function(d, b) {
          return this.add(-1 * d, b);
        }, g.format = function(d) {
          var b = this, f = this.$locale();
          if (!this.isValid()) return f.invalidDate || c;
          var P = d || "YYYY-MM-DDTHH:mm:ssZ", N = M.z(this), L = this.$H, K = this.$m, H = this.$M, G = f.weekdays, x = f.months, ce = f.meridiem, re = function(k, Q, fe, he) {
            return k && (k[Q] || k(b, P)) || fe[Q].slice(0, he);
          }, de = function(k) {
            return M.s(L % 12 || 12, k, "0");
          }, ne = ce || function(k, Q, fe) {
            var he = k < 12 ? "AM" : "PM";
            return fe ? he.toLowerCase() : he;
          };
          return P.replace(E, (function(k, Q) {
            return Q || (function(fe) {
              switch (fe) {
                case "YY":
                  return String(b.$y).slice(-2);
                case "YYYY":
                  return M.s(b.$y, 4, "0");
                case "M":
                  return H + 1;
                case "MM":
                  return M.s(H + 1, 2, "0");
                case "MMM":
                  return re(f.monthsShort, H, x, 3);
                case "MMMM":
                  return re(x, H);
                case "D":
                  return b.$D;
                case "DD":
                  return M.s(b.$D, 2, "0");
                case "d":
                  return String(b.$W);
                case "dd":
                  return re(f.weekdaysMin, b.$W, G, 2);
                case "ddd":
                  return re(f.weekdaysShort, b.$W, G, 3);
                case "dddd":
                  return G[b.$W];
                case "H":
                  return String(L);
                case "HH":
                  return M.s(L, 2, "0");
                case "h":
                  return de(1);
                case "hh":
                  return de(2);
                case "a":
                  return ne(L, K, !0);
                case "A":
                  return ne(L, K, !1);
                case "m":
                  return String(K);
                case "mm":
                  return M.s(K, 2, "0");
                case "s":
                  return String(b.$s);
                case "ss":
                  return M.s(b.$s, 2, "0");
                case "SSS":
                  return M.s(b.$ms, 3, "0");
                case "Z":
                  return N;
              }
              return null;
            })(k) || N.replace(":", "");
          }));
        }, g.utcOffset = function() {
          return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, g.diff = function(d, b, f) {
          var P, N = this, L = M.p(b), K = $(d), H = (K.utcOffset() - this.utcOffset()) * n, G = this - K, x = function() {
            return M.m(N, K);
          };
          switch (L) {
            case y:
              P = x() / 12;
              break;
            case h:
              P = x();
              break;
            case p:
              P = x() / 3;
              break;
            case D:
              P = (G - H) / 6048e5;
              break;
            case m:
              P = (G - H) / 864e5;
              break;
            case u:
              P = G / i;
              break;
            case l:
              P = G / n;
              break;
            case o:
              P = G / t;
              break;
            default:
              P = G;
          }
          return f ? P : M.a(P);
        }, g.daysInMonth = function() {
          return this.endOf(h).$D;
        }, g.$locale = function() {
          return _[this.$L];
        }, g.locale = function(d, b) {
          if (!d) return this.$L;
          var f = this.clone(), P = Y(d, b, !0);
          return P && (f.$L = P), f;
        }, g.clone = function() {
          return M.w(this.$d, this);
        }, g.toDate = function() {
          return new Date(this.valueOf());
        }, g.toJSON = function() {
          return this.isValid() ? this.toISOString() : null;
        }, g.toISOString = function() {
          return this.$d.toISOString();
        }, g.toString = function() {
          return this.$d.toUTCString();
        }, S;
      })(), pa = pe.prototype;
      return $.prototype = pa, [["$ms", s], ["$s", o], ["$m", l], ["$H", u], ["$W", m], ["$M", h], ["$y", y], ["$D", v]].forEach((function(S) {
        pa[S[1]] = function(g) {
          return this.$g(g, S[0], S[1]);
        };
      })), $.extend = function(S, g) {
        return S.$i || (S(g, pe, $), S.$i = !0), $;
      }, $.locale = Y, $.isDayjs = j, $.unix = function(S) {
        return $(1e3 * S);
      }, $.en = _[A], $.Ls = _, $.p = {}, $;
    }));
  })(Se)), Se.exports;
}
var Qr = mt();
const J = /* @__PURE__ */ I(Qr);
var Pe = { exports: {} }, en = Pe.exports, Na;
function an() {
  return Na || (Na = 1, (function(e, a) {
    (function(t, n) {
      e.exports = n();
    })(en, (function() {
      return function(t, n) {
        var i = n.prototype, s = i.format;
        i.format = function(o) {
          var l = this, u = this.$locale();
          if (!this.isValid()) return s.bind(this)(o);
          var m = this.$utils(), D = (o || "YYYY-MM-DDTHH:mm:ssZ").replace(/\[([^\]]+)]|Q|wo|ww|w|WW|W|zzz|z|gggg|GGGG|Do|X|x|k{1,2}|S/g, (function(h) {
            switch (h) {
              case "Q":
                return Math.ceil((l.$M + 1) / 3);
              case "Do":
                return u.ordinal(l.$D);
              case "gggg":
                return l.weekYear();
              case "GGGG":
                return l.isoWeekYear();
              case "wo":
                return u.ordinal(l.week(), "W");
              case "w":
              case "ww":
                return m.s(l.week(), h === "w" ? 1 : 2, "0");
              case "W":
              case "WW":
                return m.s(l.isoWeek(), h === "W" ? 1 : 2, "0");
              case "k":
              case "kk":
                return m.s(String(l.$H === 0 ? 24 : l.$H), h === "k" ? 1 : 2, "0");
              case "X":
                return Math.floor(l.$d.getTime() / 1e3);
              case "x":
                return l.$d.getTime();
              case "z":
                return "[" + l.offsetName() + "]";
              case "zzz":
                return "[" + l.offsetName("long") + "]";
              default:
                return h;
            }
          }));
          return s.bind(this)(D);
        };
      };
    }));
  })(Pe)), Pe.exports;
}
var tn = an();
const rn = /* @__PURE__ */ I(tn);
var Ne = { exports: {} }, nn = Ne.exports, Ra;
function on() {
  return Ra || (Ra = 1, (function(e, a) {
    (function(t, n) {
      e.exports = n();
    })(nn, (function() {
      return function(t, n, i) {
        n.prototype.isBetween = function(s, o, l, u) {
          var m = i(s), D = i(o), h = (u = u || "()")[0] === "(", p = u[1] === ")";
          return (h ? this.isAfter(m, l) : !this.isBefore(m, l)) && (p ? this.isBefore(D, l) : !this.isAfter(D, l)) || (h ? this.isBefore(m, l) : !this.isAfter(m, l)) && (p ? this.isAfter(D, l) : !this.isBefore(D, l));
        };
      };
    }));
  })(Ne)), Ne.exports;
}
var ln = on();
const sn = /* @__PURE__ */ I(ln);
var Re = { exports: {} }, un = Re.exports, Ma;
function cn() {
  return Ma || (Ma = 1, (function(e, a) {
    (function(t, n) {
      e.exports = n();
    })(un, (function() {
      return function(t, n) {
        n.prototype.isSameOrAfter = function(i, s) {
          return this.isSame(i, s) || this.isAfter(i, s);
        };
      };
    }));
  })(Re)), Re.exports;
}
var mn = cn();
const dn = /* @__PURE__ */ I(mn);
var Me = { exports: {} }, fn = Me.exports, Aa;
function gn() {
  return Aa || (Aa = 1, (function(e, a) {
    (function(t, n) {
      e.exports = n();
    })(fn, (function() {
      return function(t, n) {
        n.prototype.isSameOrBefore = function(i, s) {
          return this.isSame(i, s) || this.isBefore(i, s);
        };
      };
    }));
  })(Me)), Me.exports;
}
var Dn = gn();
const bn = /* @__PURE__ */ I(Dn);
var Ae = { exports: {} }, vn = Ae.exports, Oa;
function pn() {
  return Oa || (Oa = 1, (function(e, a) {
    (function(t, n) {
      e.exports = n();
    })(vn, (function() {
      var t = { LTS: "h:mm:ss A", LT: "h:mm A", L: "MM/DD/YYYY", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A" };
      return function(n, i, s) {
        var o = i.prototype, l = o.format;
        s.en.formats = t, o.format = function(u) {
          u === void 0 && (u = "YYYY-MM-DDTHH:mm:ssZ");
          var m = this.$locale().formats, D = (function(h, p) {
            return h.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, (function(y, v, c) {
              var R = c && c.toUpperCase();
              return v || p[c] || t[c] || p[R].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, (function(E, T, O) {
                return T || O.slice(1);
              }));
            }));
          })(u, m === void 0 ? {} : m);
          return l.call(this, D);
        };
      };
    }));
  })(Ae)), Ae.exports;
}
var hn = pn();
const yn = /* @__PURE__ */ I(hn);
var Oe = { exports: {} }, Sn = Oe.exports, La;
function Pn() {
  return La || (La = 1, (function(e, a) {
    (function(t, n) {
      e.exports = n();
    })(Sn, (function() {
      return function(t, n, i) {
        var s = function(o, l) {
          if (!l || !l.length || l.length === 1 && !l[0] || l.length === 1 && Array.isArray(l[0]) && !l[0].length) return null;
          var u;
          l.length === 1 && l[0].length > 0 && (l = l[0]), u = (l = l.filter((function(D) {
            return D;
          })))[0];
          for (var m = 1; m < l.length; m += 1) l[m].isValid() && !l[m][o](u) || (u = l[m]);
          return u;
        };
        i.max = function() {
          var o = [].slice.call(arguments, 0);
          return s("isAfter", o);
        }, i.min = function() {
          var o = [].slice.call(arguments, 0);
          return s("isBefore", o);
        };
      };
    }));
  })(Oe)), Oe.exports;
}
var Nn = Pn();
const Rn = /* @__PURE__ */ I(Nn);
var Le = { exports: {} }, Mn = Le.exports, Ba;
function An() {
  return Ba || (Ba = 1, (function(e, a) {
    (function(t, n) {
      e.exports = n();
    })(Mn, (function() {
      return function(t, n, i) {
        t = t || {};
        var s = n.prototype, o = { future: "in %s", past: "%s ago", s: "a few seconds", m: "a minute", mm: "%d minutes", h: "an hour", hh: "%d hours", d: "a day", dd: "%d days", M: "a month", MM: "%d months", y: "a year", yy: "%d years" };
        function l(m, D, h, p) {
          return s.fromToBase(m, D, h, p);
        }
        i.en.relativeTime = o, s.fromToBase = function(m, D, h, p, y) {
          for (var v, c, R, E = h.$locale().relativeTime || o, T = t.thresholds || [{ l: "s", r: 44, d: "second" }, { l: "m", r: 89 }, { l: "mm", r: 44, d: "minute" }, { l: "h", r: 89 }, { l: "hh", r: 21, d: "hour" }, { l: "d", r: 35 }, { l: "dd", r: 25, d: "day" }, { l: "M", r: 45 }, { l: "MM", r: 10, d: "month" }, { l: "y", r: 17 }, { l: "yy", d: "year" }], O = T.length, F = 0; F < O; F += 1) {
            var A = T[F];
            A.d && (v = p ? i(m).diff(h, A.d, !0) : h.diff(m, A.d, !0));
            var _ = (t.rounding || Math.round)(Math.abs(v));
            if (R = v > 0, _ <= A.r || !A.r) {
              _ <= 1 && F > 0 && (A = T[F - 1]);
              var U = E[A.l];
              y && (_ = y("" + _)), c = typeof U == "string" ? U.replace("%d", _) : U(_, D, A.l, R);
              break;
            }
          }
          if (D) return c;
          var j = R ? E.future : E.past;
          return typeof j == "function" ? j(c) : j.replace("%s", c);
        }, s.to = function(m, D) {
          return l(m, D, this, !0);
        }, s.from = function(m, D) {
          return l(m, D, this);
        };
        var u = function(m) {
          return m.$u ? i.utc() : i();
        };
        s.toNow = function(m) {
          return this.to(u(this), m);
        }, s.fromNow = function(m) {
          return this.from(u(this), m);
        };
      };
    }));
  })(Le)), Le.exports;
}
var On = An();
const Ln = /* @__PURE__ */ I(On);
var Be = { exports: {} }, Bn = Be.exports, Ta;
function Tn() {
  return Ta || (Ta = 1, (function(e, a) {
    (function(t, n) {
      e.exports = n();
    })(Bn, (function() {
      var t = { year: 0, month: 1, day: 2, hour: 3, minute: 4, second: 5 }, n = {};
      return function(i, s, o) {
        var l, u = function(p, y, v) {
          v === void 0 && (v = {});
          var c = new Date(p), R = (function(E, T) {
            T === void 0 && (T = {});
            var O = T.timeZoneName || "short", F = E + "|" + O, A = n[F];
            return A || (A = new Intl.DateTimeFormat("en-US", { hour12: !1, timeZone: E, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit", timeZoneName: O }), n[F] = A), A;
          })(y, v);
          return R.formatToParts(c);
        }, m = function(p, y) {
          for (var v = u(p, y), c = [], R = 0; R < v.length; R += 1) {
            var E = v[R], T = E.type, O = E.value, F = t[T];
            F >= 0 && (c[F] = parseInt(O, 10));
          }
          var A = c[3], _ = A === 24 ? 0 : A, U = c[0] + "-" + c[1] + "-" + c[2] + " " + _ + ":" + c[4] + ":" + c[5] + ":000", j = +p;
          return (o.utc(U).valueOf() - (j -= j % 1e3)) / 6e4;
        }, D = s.prototype;
        D.tz = function(p, y) {
          p === void 0 && (p = l);
          var v, c = this.utcOffset(), R = this.toDate(), E = R.toLocaleString("en-US", { timeZone: p }), T = Math.round((R - new Date(E)) / 1e3 / 60), O = 15 * -Math.round(R.getTimezoneOffset() / 15) - T;
          if (!Number(O)) v = this.utcOffset(0, y);
          else if (v = o(E, { locale: this.$L }).$set("millisecond", this.$ms).utcOffset(O, !0), y) {
            var F = v.utcOffset();
            v = v.add(c - F, "minute");
          }
          return v.$x.$timezone = p, v;
        }, D.offsetName = function(p) {
          var y = this.$x.$timezone || o.tz.guess(), v = u(this.valueOf(), y, { timeZoneName: p }).find((function(c) {
            return c.type.toLowerCase() === "timezonename";
          }));
          return v && v.value;
        };
        var h = D.startOf;
        D.startOf = function(p, y) {
          if (!this.$x || !this.$x.$timezone) return h.call(this, p, y);
          var v = o(this.format("YYYY-MM-DD HH:mm:ss:SSS"), { locale: this.$L });
          return h.call(v, p, y).tz(this.$x.$timezone, !0);
        }, o.tz = function(p, y, v) {
          var c = v && y, R = v || y || l, E = m(+o(), R);
          if (typeof p != "string") return o(p).tz(R);
          var T = (function(_, U, j) {
            var Y = _ - 60 * U * 1e3, $ = m(Y, j);
            if (U === $) return [Y, U];
            var M = m(Y -= 60 * ($ - U) * 1e3, j);
            return $ === M ? [Y, $] : [_ - 60 * Math.min($, M) * 1e3, Math.max($, M)];
          })(o.utc(p, c).valueOf(), E, R), O = T[0], F = T[1], A = o(O).utcOffset(F);
          return A.$x.$timezone = R, A;
        }, o.tz.guess = function() {
          return Intl.DateTimeFormat().resolvedOptions().timeZone;
        }, o.tz.setDefault = function(p) {
          l = p;
        };
      };
    }));
  })(Be)), Be.exports;
}
var $n = Tn();
const zn = /* @__PURE__ */ I($n);
var Te = { exports: {} }, En = Te.exports, $a;
function wn() {
  return $a || ($a = 1, (function(e, a) {
    (function(t, n) {
      e.exports = n();
    })(En, (function() {
      var t = "minute", n = /[+-]\d\d(?::?\d\d)?/g, i = /([+-]|\d\d)/g;
      return function(s, o, l) {
        var u = o.prototype;
        l.utc = function(c) {
          var R = { date: c, utc: !0, args: arguments };
          return new o(R);
        }, u.utc = function(c) {
          var R = l(this.toDate(), { locale: this.$L, utc: !0 });
          return c ? R.add(this.utcOffset(), t) : R;
        }, u.local = function() {
          return l(this.toDate(), { locale: this.$L, utc: !1 });
        };
        var m = u.parse;
        u.parse = function(c) {
          c.utc && (this.$u = !0), this.$utils().u(c.$offset) || (this.$offset = c.$offset), m.call(this, c);
        };
        var D = u.init;
        u.init = function() {
          if (this.$u) {
            var c = this.$d;
            this.$y = c.getUTCFullYear(), this.$M = c.getUTCMonth(), this.$D = c.getUTCDate(), this.$W = c.getUTCDay(), this.$H = c.getUTCHours(), this.$m = c.getUTCMinutes(), this.$s = c.getUTCSeconds(), this.$ms = c.getUTCMilliseconds();
          } else D.call(this);
        };
        var h = u.utcOffset;
        u.utcOffset = function(c, R) {
          var E = this.$utils().u;
          if (E(c)) return this.$u ? 0 : E(this.$offset) ? h.call(this) : this.$offset;
          if (typeof c == "string" && (c = (function(A) {
            A === void 0 && (A = "");
            var _ = A.match(n);
            if (!_) return null;
            var U = ("" + _[0]).match(i) || ["-", 0, 0], j = U[0], Y = 60 * +U[1] + +U[2];
            return Y === 0 ? 0 : j === "+" ? Y : -Y;
          })(c), c === null)) return this;
          var T = Math.abs(c) <= 16 ? 60 * c : c;
          if (T === 0) return this.utc(R);
          var O = this.clone();
          if (R) return O.$offset = T, O.$u = !1, O;
          var F = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
          return (O = this.local().add(T + F, t)).$offset = T, O.$x.$localOffset = F, O;
        };
        var p = u.format;
        u.format = function(c) {
          var R = c || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
          return p.call(this, R);
        }, u.valueOf = function() {
          var c = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
          return this.$d.valueOf() - 6e4 * c;
        }, u.isUTC = function() {
          return !!this.$u;
        }, u.toISOString = function() {
          return this.toDate().toISOString();
        }, u.toString = function() {
          return this.toDate().toUTCString();
        };
        var y = u.toDate;
        u.toDate = function(c) {
          return c === "s" && this.$offset ? l(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : y.call(this);
        };
        var v = u.diff;
        u.diff = function(c, R, E) {
          if (c && this.$u === c.$u) return v.call(this, c, R, E);
          var T = this.local(), O = l(c).local();
          return v.call(T, O, R, E);
        };
      };
    }));
  })(Te)), Te.exports;
}
var _n = wn();
const Kn = /* @__PURE__ */ I(_n);
var $e = { exports: {} }, Fn = $e.exports, za;
function Hn() {
  return za || (za = 1, (function(e, a) {
    (function(t, n) {
      e.exports = n(mt());
    })(Fn, (function(t) {
      function n(o) {
        return o && typeof o == "object" && "default" in o ? o : { default: o };
      }
      var i = n(t), s = { name: "fr", weekdays: "dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"), weekdaysShort: "dim._lun._mar._mer._jeu._ven._sam.".split("_"), weekdaysMin: "di_lu_ma_me_je_ve_sa".split("_"), months: "janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre".split("_"), monthsShort: "janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.".split("_"), weekStart: 1, yearStart: 4, formats: { LT: "HH:mm", LTS: "HH:mm:ss", L: "DD/MM/YYYY", LL: "D MMMM YYYY", LLL: "D MMMM YYYY HH:mm", LLLL: "dddd D MMMM YYYY HH:mm" }, relativeTime: { future: "dans %s", past: "il y a %s", s: "quelques secondes", m: "une minute", mm: "%d minutes", h: "une heure", hh: "%d heures", d: "un jour", dd: "%d jours", M: "un mois", MM: "%d mois", y: "un an", yy: "%d ans" }, ordinal: function(o) {
        return "" + o + (o === 1 ? "er" : "");
      } };
      return i.default.locale(s, null, !0), s;
    }));
  })($e)), $e.exports;
}
Hn();
var ze = { exports: {} }, Un = ze.exports, Ea;
function Gn() {
  return Ea || (Ea = 1, (function(e, a) {
    (function(t, n) {
      e.exports = n();
    })(Un, (function() {
      return { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(t) {
        var n = ["th", "st", "nd", "rd"], i = t % 100;
        return "[" + t + (n[(i - 20) % 10] || n[i] || n[0]) + "]";
      } };
    }));
  })(ze)), ze.exports;
}
Gn();
J.extend(rn);
J.extend(sn);
J.extend(dn);
J.extend(bn);
J.extend(yn);
J.extend(Rn);
J.extend(Ln);
J.extend(zn);
J.extend(Kn);
var dt = /* @__PURE__ */ ((e) => (e.AED = "AED", e.AFN = "AFN", e.ALL = "ALL", e.AMD = "AMD", e.ANG = "ANG", e.AOA = "AOA", e.ARS = "ARS", e.AUD = "AUD", e.AWG = "AWG", e.AZN = "AZN", e.BAM = "BAM", e.BBD = "BBD", e.BDT = "BDT", e.BGN = "BGN", e.BHD = "BHD", e.BIF = "BIF", e.BMD = "BMD", e.BND = "BND", e.BOB = "BOB", e.BRL = "BRL", e.BSD = "BSD", e.BTN = "BTN", e.BWP = "BWP", e.BYN = "BYN", e.BYR = "BYR", e.BZD = "BZD", e.CAD = "CAD", e.CDF = "CDF", e.CHF = "CHF", e.CLF = "CLF", e.CLP = "CLP", e.CNY = "CNY", e.COP = "COP", e.CRC = "CRC", e.CUC = "CUC", e.CUP = "CUP", e.CVE = "CVE", e.CZK = "CZK", e.DJF = "DJF", e.DKK = "DKK", e.DOP = "DOP", e.DZD = "DZD", e.EEK = "EEK", e.EGP = "EGP", e.ERN = "ERN", e.ETB = "ETB", e.EUR = "EUR", e.FJD = "FJD", e.FKP = "FKP", e.GBP = "GBP", e.GEL = "GEL", e.GHS = "GHS", e.GIP = "GIP", e.GMD = "GMD", e.GNF = "GNF", e.GTQ = "GTQ", e.GYD = "GYD", e.HKD = "HKD", e.HNL = "HNL", e.HRK = "HRK", e.HTG = "HTG", e.HUF = "HUF", e.IDR = "IDR", e.ILS = "ILS", e.INR = "INR", e.IQD = "IQD", e.IRR = "IRR", e.ISK = "ISK", e.JMD = "JMD", e.JOD = "JOD", e.JPY = "JPY", e.KES = "KES", e.KGS = "KGS", e.KHR = "KHR", e.KMF = "KMF", e.KPW = "KPW", e.KRW = "KRW", e.KWD = "KWD", e.KYD = "KYD", e.KZT = "KZT", e.LAK = "LAK", e.LBP = "LBP", e.LKR = "LKR", e.LRD = "LRD", e.LSL = "LSL", e.LTL = "LTL", e.LVL = "LVL", e.LYD = "LYD", e.MAD = "MAD", e.MDL = "MDL", e.MGA = "MGA", e.MKD = "MKD", e.MMK = "MMK", e.MNT = "MNT", e.MOP = "MOP", e.MRO = "MRO", e.MRU = "MRU", e.MUR = "MUR", e.MVR = "MVR", e.MWK = "MWK", e.MXN = "MXN", e.MYR = "MYR", e.MZN = "MZN", e.NAD = "NAD", e.NGN = "NGN", e.NIO = "NIO", e.NOK = "NOK", e.NPR = "NPR", e.NZD = "NZD", e.OMR = "OMR", e.PAB = "PAB", e.PEN = "PEN", e.PGK = "PGK", e.PHP = "PHP", e.PKR = "PKR", e.PLN = "PLN", e.PYG = "PYG", e.QAR = "QAR", e.RON = "RON", e.RSD = "RSD", e.RUB = "RUB", e.RWF = "RWF", e.SAR = "SAR", e.SBD = "SBD", e.SCR = "SCR", e.SDG = "SDG", e.SEK = "SEK", e.SGD = "SGD", e.SHP = "SHP", e.SLL = "SLL", e.SOS = "SOS", e.SRD = "SRD", e.SSP = "SSP", e.STD = "STD", e.SYP = "SYP", e.SZL = "SZL", e.THB = "THB", e.TJS = "TJS", e.TMT = "TMT", e.TND = "TND", e.TOP = "TOP", e.TRY = "TRY", e.TTD = "TTD", e.TWD = "TWD", e.TZS = "TZS", e.UAH = "UAH", e.UGX = "UGX", e.USD = "USD", e.UYU = "UYU", e.UZS = "UZS", e.VEF = "VEF", e.VES = "VES", e.VND = "VND", e.VUV = "VUV", e.WST = "WST", e.XAF = "XAF", e.XCD = "XCD", e.XOF = "XOF", e.XPF = "XPF", e.YER = "YER", e.ZAR = "ZAR", e.ZMK = "ZMK", e.ZMW = "ZMW", e.ZWL = "ZWL", e))(dt || {}), ft = /* @__PURE__ */ ((e) => (e.Production = "LIVE", e.Sandbox = "SANDBOX", e.Staging = "STAGING", e.CiCd = "CI-CD", e.Local = "LOCAL", e))(ft || {}), gt = /* @__PURE__ */ ((e) => (e.de_DE = "de-DE", e.en_US = "en-US", e.es_ES = "es-ES", e.fr_FR = "fr-FR", e.it_IT = "it-IT", e.nl_NL = "nl-NL", e.pt_PT = "pt-PT", e))(gt || {});
ft.Local, dt.EUR;
gt.en_US;
var Dt = /* @__PURE__ */ ((e) => (e.BookingCreated = "booking:created", e.BookingManagerNewBooking = "booking-manager:new-booking", e.BookingManagerRetrieve = "booking-manager:retrieve", e.BookingManagerRetrieveFail = "booking-manager:retrieve-fail", e.BookingPolicyCreated = "booking-policy:created", e.CancellationPoliciesUpdated = "cancellation-policies:updated", e.CurrencyUpdated = "currency:updated", e.HotelOfferItemVisible = "hotel-offer:item:visible", e.HotelOfferItemMouseover = "hotel-offer:item:mouseover", e.HotelOffersFiltersUpdated = "hotel-offers:filters:updated", e.HotelOfferItemMouseleave = "hotel-offer:item:mouseleave", e.HotelOffersItemClick = "hotel-offer-item:click", e.HotelOffersMarkerClick = "hotel-offers:marker:click", e.HotelOffersPollingStarted = "hotel-offers:polling:started", e.HotelOffersRetrieved = "hotel-offers:retrieved", e.HotelOfferRequestCreated = "hotel-offer-request:created", e.HotelOfferRequestRetrieved = "hotel-offer-request:retrieved", e.HotelRetrieved = "hotel:retrieved", e.HotelRoomOffersBtnClick = "hotel-room-offers:click:btn", e.HotelRoomOffersPriceIncreased = "hotel-room-offers:price-increased", e.HotelRoomOffersRetrieved = "hotel-room-offers:retrieved", e.HotelRoomOfferRequestCreated = "hotel-room-offer-request:created", e.HotelRoomOfferRequestRetrieved = "hotel-room-offer-request:retrieved", e.LangUpdated = "lang:updated", e.PaymentSuccess = "payment:success", e.PrebookForm = "prebook:form", e.BookingFlowStepUpdated = "booking-flow-step:updated", e.HotelOffersViewShowMap = "hotel-offers-view:show-map", e))(Dt || {}), jn = /* @__PURE__ */ ((e) => (e.Idle = "IDLE", e.PaymentRequested = "PAYMENT_REQUESTED", e.PaymentSuccessful = "PAYMENT_SUCCESSFUL", e.Prebook = "PREBOOK", e))(jn || {});
const kn = {
  accent3: "#ff1744"
}, Yn = {
  lighten2: "#64b5f6"
}, xn = {
  base: "#4caf50"
}, pu = {
  colors: {
    accent: "#f57f39",
    error: kn.accent3,
    "on-primary": "#fff",
    "on-secondary": "#fff",
    primary: "#007fff",
    secondary: Yn.lighten2,
    success: xn.base
  }
}, In = "revolugo-vue-", Cn = "revolugo-";
function w(e, a) {
  if (!e.includes(Cn))
    throw new Error(
      "Wrapped revolugo element tag name must start with 'revolugo-' prefix"
      /* WrongTagName */
    );
  return Or({
    name: e.replace(/revolugo-/u, In),
    props: a || {},
    setup(n, { emit: i }) {
      if (!window.RevolugoElements.ready)
        throw new Error(
          "Revolugo Elements is not loaded. Please make sure you are using Revolugo Elements plugin"
          /* NotLoaded */
        );
      window.RevolugoElements.ready(() => {
        if (!window.RevolugoElements.eventBus)
          throw new Error(
            "Revolugo Elements is not loaded. Please make sure you are using Revolugo Elements plugin"
            /* NotLoaded */
          );
        for (const o of Object.values(Dt))
          window.RevolugoElements.eventBus.$on(
            o,
            (l) => {
              i(o, l);
            }
          );
      });
      const s = Lr(() => {
        const o = Ie(n, ct.Param, {
          deep: !1
        });
        return Object.keys(o).reduce(
          (l, u) => (o[u] === null || o[u] === void 0 ? l[`^${u}`] = null : typeof o[u] == "object" ? l[`^${u}`] = JSON.stringify(o[u]) : l[`^${u}`] = o[u], l),
          {}
        );
      });
      return () => Br(e, s.value);
    }
  });
}
const bt = 50, Zn = {
  CreditCard: "CREDIT_CARD"
}, vt = {
  BookingDetails: !0
};
var pt = typeof global == "object" && global && global.Object === Object && global, Vn = typeof self == "object" && self && self.Object === Object && self, Z = pt || Vn || Function("return this")(), C = Z.Symbol, ht = Object.prototype, Wn = ht.hasOwnProperty, qn = ht.toString, ge = C ? C.toStringTag : void 0;
function Jn(e) {
  var a = Wn.call(e, ge), t = e[ge];
  try {
    e[ge] = void 0;
    var n = !0;
  } catch {
  }
  var i = qn.call(e);
  return n && (a ? e[ge] = t : delete e[ge]), i;
}
var Xn = Object.prototype, Qn = Xn.toString;
function ei(e) {
  return Qn.call(e);
}
var ai = "[object Null]", ti = "[object Undefined]", wa = C ? C.toStringTag : void 0;
function oe(e) {
  return e == null ? e === void 0 ? ti : ai : wa && wa in Object(e) ? Jn(e) : ei(e);
}
function ee(e) {
  return e != null && typeof e == "object";
}
var ri = "[object Symbol]";
function aa(e) {
  return typeof e == "symbol" || ee(e) && oe(e) == ri;
}
function yt(e, a) {
  for (var t = -1, n = e == null ? 0 : e.length, i = Array(n); ++t < n; )
    i[t] = a(e[t], t, e);
  return i;
}
var q = Array.isArray, _a = C ? C.prototype : void 0, Ka = _a ? _a.toString : void 0;
function St(e) {
  if (typeof e == "string")
    return e;
  if (q(e))
    return yt(e, St) + "";
  if (aa(e))
    return Ka ? Ka.call(e) : "";
  var a = e + "";
  return a == "0" && 1 / e == -1 / 0 ? "-0" : a;
}
function ae(e) {
  var a = typeof e;
  return e != null && (a == "object" || a == "function");
}
function Pt(e) {
  return e;
}
var ni = "[object AsyncFunction]", ii = "[object Function]", oi = "[object GeneratorFunction]", li = "[object Proxy]";
function ta(e) {
  if (!ae(e))
    return !1;
  var a = oe(e);
  return a == ii || a == oi || a == ni || a == li;
}
var ke = Z["__core-js_shared__"], Fa = (function() {
  var e = /[^.]+$/.exec(ke && ke.keys && ke.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
})();
function si(e) {
  return !!Fa && Fa in e;
}
var ui = Function.prototype, ci = ui.toString;
function le(e) {
  if (e != null) {
    try {
      return ci.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var mi = /[\\^$.*+?()[\]{}|]/g, di = /^\[object .+?Constructor\]$/, fi = Function.prototype, gi = Object.prototype, Di = fi.toString, bi = gi.hasOwnProperty, vi = RegExp(
  "^" + Di.call(bi).replace(mi, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function pi(e) {
  if (!ae(e) || si(e))
    return !1;
  var a = ta(e) ? vi : di;
  return a.test(le(e));
}
function hi(e, a) {
  return e?.[a];
}
function se(e, a) {
  var t = hi(e, a);
  return pi(t) ? t : void 0;
}
var Ce = se(Z, "WeakMap"), Ha = Object.create, yi = /* @__PURE__ */ (function() {
  function e() {
  }
  return function(a) {
    if (!ae(a))
      return {};
    if (Ha)
      return Ha(a);
    e.prototype = a;
    var t = new e();
    return e.prototype = void 0, t;
  };
})();
function Si(e, a, t) {
  switch (t.length) {
    case 0:
      return e.call(a);
    case 1:
      return e.call(a, t[0]);
    case 2:
      return e.call(a, t[0], t[1]);
    case 3:
      return e.call(a, t[0], t[1], t[2]);
  }
  return e.apply(a, t);
}
function Pi(e, a) {
  var t = -1, n = e.length;
  for (a || (a = Array(n)); ++t < n; )
    a[t] = e[t];
  return a;
}
var Ni = 800, Ri = 16, Mi = Date.now;
function Ai(e) {
  var a = 0, t = 0;
  return function() {
    var n = Mi(), i = Ri - (n - t);
    if (t = n, i > 0) {
      if (++a >= Ni)
        return arguments[0];
    } else
      a = 0;
    return e.apply(void 0, arguments);
  };
}
function Oi(e) {
  return function() {
    return e;
  };
}
var we = (function() {
  try {
    var e = se(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
})(), Li = we ? function(e, a) {
  return we(e, "toString", {
    configurable: !0,
    enumerable: !1,
    value: Oi(a),
    writable: !0
  });
} : Pt, Nt = Ai(Li);
function Bi(e, a) {
  for (var t = -1, n = e == null ? 0 : e.length; ++t < n && a(e[t], t, e) !== !1; )
    ;
  return e;
}
var Ti = 9007199254740991, $i = /^(?:0|[1-9]\d*)$/;
function Rt(e, a) {
  var t = typeof e;
  return a = a ?? Ti, !!a && (t == "number" || t != "symbol" && $i.test(e)) && e > -1 && e % 1 == 0 && e < a;
}
function ra(e, a, t) {
  a == "__proto__" && we ? we(e, a, {
    configurable: !0,
    enumerable: !0,
    value: t,
    writable: !0
  }) : e[a] = t;
}
function Ue(e, a) {
  return e === a || e !== e && a !== a;
}
var zi = Object.prototype, Ei = zi.hasOwnProperty;
function Mt(e, a, t) {
  var n = e[a];
  (!(Ei.call(e, a) && Ue(n, t)) || t === void 0 && !(a in e)) && ra(e, a, t);
}
function At(e, a, t, n) {
  var i = !t;
  t || (t = {});
  for (var s = -1, o = a.length; ++s < o; ) {
    var l = a[s], u = void 0;
    u === void 0 && (u = e[l]), i ? ra(t, l, u) : Mt(t, l, u);
  }
  return t;
}
var Ua = Math.max;
function Ot(e, a, t) {
  return a = Ua(a === void 0 ? e.length - 1 : a, 0), function() {
    for (var n = arguments, i = -1, s = Ua(n.length - a, 0), o = Array(s); ++i < s; )
      o[i] = n[a + i];
    i = -1;
    for (var l = Array(a + 1); ++i < a; )
      l[i] = n[i];
    return l[a] = t(o), Si(e, this, l);
  };
}
function wi(e, a) {
  return Nt(Ot(e, a, Pt), e + "");
}
var _i = 9007199254740991;
function Lt(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= _i;
}
function na(e) {
  return e != null && Lt(e.length) && !ta(e);
}
function Ki(e, a, t) {
  if (!ae(t))
    return !1;
  var n = typeof a;
  return (n == "number" ? na(t) && Rt(a, t.length) : n == "string" && a in t) ? Ue(t[a], e) : !1;
}
function Fi(e) {
  return wi(function(a, t) {
    var n = -1, i = t.length, s = i > 1 ? t[i - 1] : void 0, o = i > 2 ? t[2] : void 0;
    for (s = e.length > 3 && typeof s == "function" ? (i--, s) : void 0, o && Ki(t[0], t[1], o) && (s = i < 3 ? void 0 : s, i = 1), a = Object(a); ++n < i; ) {
      var l = t[n];
      l && e(a, l, n, s);
    }
    return a;
  });
}
var Hi = Object.prototype;
function Bt(e) {
  var a = e && e.constructor, t = typeof a == "function" && a.prototype || Hi;
  return e === t;
}
function Ui(e, a) {
  for (var t = -1, n = Array(e); ++t < e; )
    n[t] = a(t);
  return n;
}
var Gi = "[object Arguments]";
function Ga(e) {
  return ee(e) && oe(e) == Gi;
}
var Tt = Object.prototype, ji = Tt.hasOwnProperty, ki = Tt.propertyIsEnumerable, _e = Ga(/* @__PURE__ */ (function() {
  return arguments;
})()) ? Ga : function(e) {
  return ee(e) && ji.call(e, "callee") && !ki.call(e, "callee");
};
function Yi() {
  return !1;
}
var $t = typeof exports == "object" && exports && !exports.nodeType && exports, ja = $t && typeof module == "object" && module && !module.nodeType && module, xi = ja && ja.exports === $t, ka = xi ? Z.Buffer : void 0, Ii = ka ? ka.isBuffer : void 0, ia = Ii || Yi, Ci = "[object Arguments]", Zi = "[object Array]", Vi = "[object Boolean]", Wi = "[object Date]", qi = "[object Error]", Ji = "[object Function]", Xi = "[object Map]", Qi = "[object Number]", eo = "[object Object]", ao = "[object RegExp]", to = "[object Set]", ro = "[object String]", no = "[object WeakMap]", io = "[object ArrayBuffer]", oo = "[object DataView]", lo = "[object Float32Array]", so = "[object Float64Array]", uo = "[object Int8Array]", co = "[object Int16Array]", mo = "[object Int32Array]", fo = "[object Uint8Array]", go = "[object Uint8ClampedArray]", Do = "[object Uint16Array]", bo = "[object Uint32Array]", z = {};
z[lo] = z[so] = z[uo] = z[co] = z[mo] = z[fo] = z[go] = z[Do] = z[bo] = !0;
z[Ci] = z[Zi] = z[io] = z[Vi] = z[oo] = z[Wi] = z[qi] = z[Ji] = z[Xi] = z[Qi] = z[eo] = z[ao] = z[to] = z[ro] = z[no] = !1;
function vo(e) {
  return ee(e) && Lt(e.length) && !!z[oe(e)];
}
function oa(e) {
  return function(a) {
    return e(a);
  };
}
var zt = typeof exports == "object" && exports && !exports.nodeType && exports, De = zt && typeof module == "object" && module && !module.nodeType && module, po = De && De.exports === zt, Ye = po && pt.process, me = (function() {
  try {
    var e = De && De.require && De.require("util").types;
    return e || Ye && Ye.binding && Ye.binding("util");
  } catch {
  }
})(), Ya = me && me.isTypedArray, Et = Ya ? oa(Ya) : vo;
function ho(e, a) {
  var t = q(e), n = !t && _e(e), i = !t && !n && ia(e), s = !t && !n && !i && Et(e), o = t || n || i || s, l = o ? Ui(e.length, String) : [], u = l.length;
  for (var m in e)
    o && // Safari 9 has enumerable `arguments.length` in strict mode.
    (m == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    i && (m == "offset" || m == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    s && (m == "buffer" || m == "byteLength" || m == "byteOffset") || // Skip index properties.
    Rt(m, u)) || l.push(m);
  return l;
}
function yo(e, a) {
  return function(t) {
    return e(a(t));
  };
}
function So(e) {
  var a = [];
  if (e != null)
    for (var t in Object(e))
      a.push(t);
  return a;
}
var Po = Object.prototype, No = Po.hasOwnProperty;
function Ro(e) {
  if (!ae(e))
    return So(e);
  var a = Bt(e), t = [];
  for (var n in e)
    n == "constructor" && (a || !No.call(e, n)) || t.push(n);
  return t;
}
function la(e) {
  return na(e) ? ho(e) : Ro(e);
}
var Mo = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Ao = /^\w*$/;
function Oo(e, a) {
  if (q(e))
    return !1;
  var t = typeof e;
  return t == "number" || t == "symbol" || t == "boolean" || e == null || aa(e) ? !0 : Ao.test(e) || !Mo.test(e) || a != null && e in Object(a);
}
var be = se(Object, "create");
function Lo() {
  this.__data__ = be ? be(null) : {}, this.size = 0;
}
function Bo(e) {
  var a = this.has(e) && delete this.__data__[e];
  return this.size -= a ? 1 : 0, a;
}
var To = "__lodash_hash_undefined__", $o = Object.prototype, zo = $o.hasOwnProperty;
function Eo(e) {
  var a = this.__data__;
  if (be) {
    var t = a[e];
    return t === To ? void 0 : t;
  }
  return zo.call(a, e) ? a[e] : void 0;
}
var wo = Object.prototype, _o = wo.hasOwnProperty;
function Ko(e) {
  var a = this.__data__;
  return be ? a[e] !== void 0 : _o.call(a, e);
}
var Fo = "__lodash_hash_undefined__";
function Ho(e, a) {
  var t = this.__data__;
  return this.size += this.has(e) ? 0 : 1, t[e] = be && a === void 0 ? Fo : a, this;
}
function ie(e) {
  var a = -1, t = e == null ? 0 : e.length;
  for (this.clear(); ++a < t; ) {
    var n = e[a];
    this.set(n[0], n[1]);
  }
}
ie.prototype.clear = Lo;
ie.prototype.delete = Bo;
ie.prototype.get = Eo;
ie.prototype.has = Ko;
ie.prototype.set = Ho;
function Uo() {
  this.__data__ = [], this.size = 0;
}
function Ge(e, a) {
  for (var t = e.length; t--; )
    if (Ue(e[t][0], a))
      return t;
  return -1;
}
var Go = Array.prototype, jo = Go.splice;
function ko(e) {
  var a = this.__data__, t = Ge(a, e);
  if (t < 0)
    return !1;
  var n = a.length - 1;
  return t == n ? a.pop() : jo.call(a, t, 1), --this.size, !0;
}
function Yo(e) {
  var a = this.__data__, t = Ge(a, e);
  return t < 0 ? void 0 : a[t][1];
}
function xo(e) {
  return Ge(this.__data__, e) > -1;
}
function Io(e, a) {
  var t = this.__data__, n = Ge(t, e);
  return n < 0 ? (++this.size, t.push([e, a])) : t[n][1] = a, this;
}
function X(e) {
  var a = -1, t = e == null ? 0 : e.length;
  for (this.clear(); ++a < t; ) {
    var n = e[a];
    this.set(n[0], n[1]);
  }
}
X.prototype.clear = Uo;
X.prototype.delete = ko;
X.prototype.get = Yo;
X.prototype.has = xo;
X.prototype.set = Io;
var ve = se(Z, "Map");
function Co() {
  this.size = 0, this.__data__ = {
    hash: new ie(),
    map: new (ve || X)(),
    string: new ie()
  };
}
function Zo(e) {
  var a = typeof e;
  return a == "string" || a == "number" || a == "symbol" || a == "boolean" ? e !== "__proto__" : e === null;
}
function je(e, a) {
  var t = e.__data__;
  return Zo(a) ? t[typeof a == "string" ? "string" : "hash"] : t.map;
}
function Vo(e) {
  var a = je(this, e).delete(e);
  return this.size -= a ? 1 : 0, a;
}
function Wo(e) {
  return je(this, e).get(e);
}
function qo(e) {
  return je(this, e).has(e);
}
function Jo(e, a) {
  var t = je(this, e), n = t.size;
  return t.set(e, a), this.size += t.size == n ? 0 : 1, this;
}
function te(e) {
  var a = -1, t = e == null ? 0 : e.length;
  for (this.clear(); ++a < t; ) {
    var n = e[a];
    this.set(n[0], n[1]);
  }
}
te.prototype.clear = Co;
te.prototype.delete = Vo;
te.prototype.get = Wo;
te.prototype.has = qo;
te.prototype.set = Jo;
var Xo = "Expected a function";
function sa(e, a) {
  if (typeof e != "function" || a != null && typeof a != "function")
    throw new TypeError(Xo);
  var t = function() {
    var n = arguments, i = a ? a.apply(this, n) : n[0], s = t.cache;
    if (s.has(i))
      return s.get(i);
    var o = e.apply(this, n);
    return t.cache = s.set(i, o) || s, o;
  };
  return t.cache = new (sa.Cache || te)(), t;
}
sa.Cache = te;
var Qo = 500;
function el(e) {
  var a = sa(e, function(n) {
    return t.size === Qo && t.clear(), n;
  }), t = a.cache;
  return a;
}
var al = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, tl = /\\(\\)?/g, rl = el(function(e) {
  var a = [];
  return e.charCodeAt(0) === 46 && a.push(""), e.replace(al, function(t, n, i, s) {
    a.push(i ? s.replace(tl, "$1") : n || t);
  }), a;
});
function nl(e) {
  return e == null ? "" : St(e);
}
function ua(e, a) {
  return q(e) ? e : Oo(e, a) ? [e] : rl(nl(e));
}
function wt(e) {
  if (typeof e == "string" || aa(e))
    return e;
  var a = e + "";
  return a == "0" && 1 / e == -1 / 0 ? "-0" : a;
}
function il(e, a) {
  a = ua(a, e);
  for (var t = 0, n = a.length; e != null && t < n; )
    e = e[wt(a[t++])];
  return t && t == n ? e : void 0;
}
function ca(e, a) {
  for (var t = -1, n = a.length, i = e.length; ++t < n; )
    e[i + t] = a[t];
  return e;
}
var xa = C ? C.isConcatSpreadable : void 0;
function ol(e) {
  return q(e) || _e(e) || !!(xa && e && e[xa]);
}
function ll(e, a, t, n, i) {
  var s = -1, o = e.length;
  for (t || (t = ol), i || (i = []); ++s < o; ) {
    var l = e[s];
    t(l) ? ca(i, l) : i[i.length] = l;
  }
  return i;
}
function sl(e) {
  var a = e == null ? 0 : e.length;
  return a ? ll(e) : [];
}
function ul(e) {
  return Nt(Ot(e, void 0, sl), e + "");
}
var ma = yo(Object.getPrototypeOf, Object), cl = "[object Object]", ml = Function.prototype, dl = Object.prototype, _t = ml.toString, fl = dl.hasOwnProperty, gl = _t.call(Object);
function Kt(e) {
  if (!ee(e) || oe(e) != cl)
    return !1;
  var a = ma(e);
  if (a === null)
    return !0;
  var t = fl.call(a, "constructor") && a.constructor;
  return typeof t == "function" && t instanceof t && _t.call(t) == gl;
}
function Dl(e, a, t) {
  var n = -1, i = e.length;
  a < 0 && (a = -a > i ? 0 : i + a), t = t > i ? i : t, t < 0 && (t += i), i = a > t ? 0 : t - a >>> 0, a >>>= 0;
  for (var s = Array(i); ++n < i; )
    s[n] = e[n + a];
  return s;
}
function bl() {
  this.__data__ = new X(), this.size = 0;
}
function vl(e) {
  var a = this.__data__, t = a.delete(e);
  return this.size = a.size, t;
}
function pl(e) {
  return this.__data__.get(e);
}
function hl(e) {
  return this.__data__.has(e);
}
var yl = 200;
function Sl(e, a) {
  var t = this.__data__;
  if (t instanceof X) {
    var n = t.__data__;
    if (!ve || n.length < yl - 1)
      return n.push([e, a]), this.size = ++t.size, this;
    t = this.__data__ = new te(n);
  }
  return t.set(e, a), this.size = t.size, this;
}
function ue(e) {
  var a = this.__data__ = new X(e);
  this.size = a.size;
}
ue.prototype.clear = bl;
ue.prototype.delete = vl;
ue.prototype.get = pl;
ue.prototype.has = hl;
ue.prototype.set = Sl;
var Ft = typeof exports == "object" && exports && !exports.nodeType && exports, Ia = Ft && typeof module == "object" && module && !module.nodeType && module, Pl = Ia && Ia.exports === Ft, Ca = Pl ? Z.Buffer : void 0, Za = Ca ? Ca.allocUnsafe : void 0;
function Ht(e, a) {
  if (a)
    return e.slice();
  var t = e.length, n = Za ? Za(t) : new e.constructor(t);
  return e.copy(n), n;
}
function Nl(e, a) {
  for (var t = -1, n = e == null ? 0 : e.length, i = 0, s = []; ++t < n; ) {
    var o = e[t];
    a(o, t, e) && (s[i++] = o);
  }
  return s;
}
function Ut() {
  return [];
}
var Rl = Object.prototype, Ml = Rl.propertyIsEnumerable, Va = Object.getOwnPropertySymbols, Al = Va ? function(e) {
  return e == null ? [] : (e = Object(e), Nl(Va(e), function(a) {
    return Ml.call(e, a);
  }));
} : Ut, Ol = Object.getOwnPropertySymbols, Ll = Ol ? function(e) {
  for (var a = []; e; )
    ca(a, Al(e)), e = ma(e);
  return a;
} : Ut;
function Bl(e, a, t) {
  var n = a(e);
  return q(e) ? n : ca(n, t(e));
}
function Gt(e) {
  return Bl(e, la, Ll);
}
var Ze = se(Z, "DataView"), Ve = se(Z, "Promise"), We = se(Z, "Set"), Wa = "[object Map]", Tl = "[object Object]", qa = "[object Promise]", Ja = "[object Set]", Xa = "[object WeakMap]", Qa = "[object DataView]", $l = le(Ze), zl = le(ve), El = le(Ve), wl = le(We), _l = le(Ce), V = oe;
(Ze && V(new Ze(new ArrayBuffer(1))) != Qa || ve && V(new ve()) != Wa || Ve && V(Ve.resolve()) != qa || We && V(new We()) != Ja || Ce && V(new Ce()) != Xa) && (V = function(e) {
  var a = oe(e), t = a == Tl ? e.constructor : void 0, n = t ? le(t) : "";
  if (n)
    switch (n) {
      case $l:
        return Qa;
      case zl:
        return Wa;
      case El:
        return qa;
      case wl:
        return Ja;
      case _l:
        return Xa;
    }
  return a;
});
var Kl = Object.prototype, Fl = Kl.hasOwnProperty;
function Hl(e) {
  var a = e.length, t = new e.constructor(a);
  return a && typeof e[0] == "string" && Fl.call(e, "index") && (t.index = e.index, t.input = e.input), t;
}
var et = Z.Uint8Array;
function da(e) {
  var a = new e.constructor(e.byteLength);
  return new et(a).set(new et(e)), a;
}
function Ul(e, a) {
  var t = da(e.buffer);
  return new e.constructor(t, e.byteOffset, e.byteLength);
}
var Gl = /\w*$/;
function jl(e) {
  var a = new e.constructor(e.source, Gl.exec(e));
  return a.lastIndex = e.lastIndex, a;
}
var at = C ? C.prototype : void 0, tt = at ? at.valueOf : void 0;
function kl(e) {
  return tt ? Object(tt.call(e)) : {};
}
function jt(e, a) {
  var t = a ? da(e.buffer) : e.buffer;
  return new e.constructor(t, e.byteOffset, e.length);
}
var Yl = "[object Boolean]", xl = "[object Date]", Il = "[object Map]", Cl = "[object Number]", Zl = "[object RegExp]", Vl = "[object Set]", Wl = "[object String]", ql = "[object Symbol]", Jl = "[object ArrayBuffer]", Xl = "[object DataView]", Ql = "[object Float32Array]", es = "[object Float64Array]", as = "[object Int8Array]", ts = "[object Int16Array]", rs = "[object Int32Array]", ns = "[object Uint8Array]", is = "[object Uint8ClampedArray]", os = "[object Uint16Array]", ls = "[object Uint32Array]";
function ss(e, a, t) {
  var n = e.constructor;
  switch (a) {
    case Jl:
      return da(e);
    case Yl:
    case xl:
      return new n(+e);
    case Xl:
      return Ul(e);
    case Ql:
    case es:
    case as:
    case ts:
    case rs:
    case ns:
    case is:
    case os:
    case ls:
      return jt(e, t);
    case Il:
      return new n();
    case Cl:
    case Wl:
      return new n(e);
    case Zl:
      return jl(e);
    case Vl:
      return new n();
    case ql:
      return kl(e);
  }
}
function us(e) {
  return typeof e.constructor == "function" && !Bt(e) ? yi(ma(e)) : {};
}
var cs = "[object Map]";
function ms(e) {
  return ee(e) && V(e) == cs;
}
var rt = me && me.isMap, ds = rt ? oa(rt) : ms, fs = "[object Set]";
function gs(e) {
  return ee(e) && V(e) == fs;
}
var nt = me && me.isSet, Ds = nt ? oa(nt) : gs, bs = 1, kt = "[object Arguments]", vs = "[object Array]", ps = "[object Boolean]", hs = "[object Date]", ys = "[object Error]", Yt = "[object Function]", Ss = "[object GeneratorFunction]", Ps = "[object Map]", Ns = "[object Number]", xt = "[object Object]", Rs = "[object RegExp]", Ms = "[object Set]", As = "[object String]", Os = "[object Symbol]", Ls = "[object WeakMap]", Bs = "[object ArrayBuffer]", Ts = "[object DataView]", $s = "[object Float32Array]", zs = "[object Float64Array]", Es = "[object Int8Array]", ws = "[object Int16Array]", _s = "[object Int32Array]", Ks = "[object Uint8Array]", Fs = "[object Uint8ClampedArray]", Hs = "[object Uint16Array]", Us = "[object Uint32Array]", B = {};
B[kt] = B[vs] = B[Bs] = B[Ts] = B[ps] = B[hs] = B[$s] = B[zs] = B[Es] = B[ws] = B[_s] = B[Ps] = B[Ns] = B[xt] = B[Rs] = B[Ms] = B[As] = B[Os] = B[Ks] = B[Fs] = B[Hs] = B[Us] = !0;
B[ys] = B[Yt] = B[Ls] = !1;
function Ee(e, a, t, n, i, s) {
  var o, l = a & bs;
  if (t && (o = i ? t(e, n, i, s) : t(e)), o !== void 0)
    return o;
  if (!ae(e))
    return e;
  var u = q(e);
  if (u)
    o = Hl(e);
  else {
    var m = V(e), D = m == Yt || m == Ss;
    if (ia(e))
      return Ht(e, l);
    if (m == xt || m == kt || D && !i)
      o = {};
    else {
      if (!B[m])
        return i ? e : {};
      o = ss(e, m, l);
    }
  }
  s || (s = new ue());
  var h = s.get(e);
  if (h)
    return h;
  s.set(e, o), Ds(e) ? e.forEach(function(v) {
    o.add(Ee(v, a, t, v, e, s));
  }) : ds(e) && e.forEach(function(v, c) {
    o.set(c, Ee(v, a, t, c, e, s));
  });
  var p = Gt, y = u ? void 0 : p(e);
  return Bi(y || e, function(v, c) {
    y && (c = v, v = e[c]), Mt(o, c, Ee(v, a, t, c, e, s));
  }), o;
}
function Gs(e) {
  return function(a, t, n) {
    for (var i = -1, s = Object(a), o = n(a), l = o.length; l--; ) {
      var u = o[++i];
      if (t(s[u], u, s) === !1)
        break;
    }
    return a;
  };
}
var js = Gs();
function qe(e, a, t) {
  (t !== void 0 && !Ue(e[a], t) || t === void 0 && !(a in e)) && ra(e, a, t);
}
function ks(e) {
  return ee(e) && na(e);
}
function Je(e, a) {
  if (!(a === "constructor" && typeof e[a] == "function") && a != "__proto__")
    return e[a];
}
function Ys(e) {
  return At(e, la(e));
}
function xs(e, a, t, n, i, s, o) {
  var l = Je(e, t), u = Je(a, t), m = o.get(u);
  if (m) {
    qe(e, t, m);
    return;
  }
  var D = s ? s(l, u, t + "", e, a, o) : void 0, h = D === void 0;
  if (h) {
    var p = q(u), y = !p && ia(u), v = !p && !y && Et(u);
    D = u, p || y || v ? q(l) ? D = l : ks(l) ? D = Pi(l) : y ? (h = !1, D = Ht(u, !0)) : v ? (h = !1, D = jt(u, !0)) : D = [] : Kt(u) || _e(u) ? (D = l, _e(l) ? D = Ys(l) : (!ae(l) || ta(l)) && (D = us(u))) : h = !1;
  }
  h && (o.set(u, D), i(D, u, n, s, o), o.delete(u)), qe(e, t, D);
}
function It(e, a, t, n, i) {
  e !== a && js(a, function(s, o) {
    if (i || (i = new ue()), ae(s))
      xs(e, a, o, t, It, n, i);
    else {
      var l = n ? n(Je(e, o), s, o + "", e, a, i) : void 0;
      l === void 0 && (l = s), qe(e, o, l);
    }
  }, la);
}
function Is(e) {
  var a = e == null ? 0 : e.length;
  return a ? e[a - 1] : void 0;
}
function Cs(e, a) {
  return a.length < 2 ? e : il(e, Dl(a, 0, -1));
}
var it = Fi(function(e, a, t) {
  It(e, a, t);
});
function Zs(e, a) {
  return a = ua(a, e), e = Cs(e, a), e == null || delete e[wt(Is(a))];
}
function Vs(e) {
  return Kt(e) ? void 0 : e;
}
var Ws = 1, qs = 2, Js = 4, fa = ul(function(e, a) {
  var t = {};
  if (e == null)
    return t;
  var n = !1;
  a = yt(a, function(s) {
    return s = ua(s, e), n || (n = s.length > 1), s;
  }), At(e, Gt(e), t), n && (t = Ee(t, Ws | qs | Js, Vs));
  for (var i = a.length; i--; )
    Zs(t, a[i]);
  return t;
}), W = /* @__PURE__ */ ((e) => (e.DialogFullscreen = "DialogFullscreen", e.HotelDescriptionViewDialog = "HotelDescriptionViewDialog", e.HotelRoomOfferList = "HotelRoomOfferList", e.HotelRoomOffersViewDialog = "HotelRoomOffersViewDialog", e.RoomsDetails = "RoomsDetails", e))(W || {});
const Ke = {
  DialogFullscreen: !0,
  HotelDescriptionViewDialog: !1,
  HotelRoomOfferList: !1,
  HotelRoomOffersViewDialog: !1,
  RoomsDetails: !0
}, Ct = {
  FiltersBar: !0,
  HotelOfferSearchMenu: !1,
  TermsAndConditionsFooter: !0,
  HotelOfferItem: Ke
}, ga = {
  LocationInput: !0,
  SearchAreaButton: !0,
  HotelOfferItem: {
    ...Ke,
    [W.HotelDescriptionViewDialog]: !1,
    [W.HotelRoomOffersViewDialog]: !1,
    [W.RoomsDetails]: !0
  }
}, Zt = {
  HotelSearchBar: !0,
  PreferencesMenu: !0,
  HotelOfferList: Ct,
  HotelOffersMap: ga
}, Da = {
  BookingDetails: !0
}, Xs = {
  HotelOffersView: it(structuredClone(Zt), {
    HotelOfferList: {
      HotelOfferItem: {
        ...Ke,
        [W.HotelRoomOfferList]: !0,
        [W.HotelRoomOffersViewDialog]: !0,
        [W.RoomsDetails]: !0
      }
    },
    HotelOffersMap: it(structuredClone(ga), {
      HotelOfferItem: {
        ...Ke,
        [W.HotelRoomOffersViewDialog]: !0,
        [W.RoomsDetails]: !0
      }
    })
  }),
  PaymentForm: vt,
  PrebookForm: Da
}, Vt = {
  PreferencesMenu: !1
}, Wt = {
  OnlyMatchingRoomCount: !1
}, qt = {
  HotelDescriptionView: Vt,
  HotelRoomOfferList: Wt
}, Qs = {
  HotelRoomOffersView: qt,
  PrebookForm: Da
}, eu = {
  block: {
    default: !1,
    type: Boolean
  },
  color: {
    default: "secondary",
    type: String
  },
  compact: {
    default: !1,
    type: Boolean
  },
  direction: {
    default: "top",
    type: String
  }
}, au = {
  amount: {
    required: !0,
    type: Number
  },
  currency: {
    required: !0,
    type: String
  },
  loading: {
    default: !1,
    type: Boolean
  },
  token: {
    required: !0,
    type: String
  },
  withTerms: {
    default: !1,
    type: Boolean
  }
}, tu = {
  adultCount: {
    required: !0,
    type: Number
  },
  checkInDate: {
    required: !0,
    type: String
  },
  checkOutDate: {
    required: !0,
    type: String
  },
  hotelRoomOffer: {
    required: !0,
    type: [Object]
  }
}, ru = {
  token: {
    type: String
  }
}, Jt = {
  cancellationPolicies: {
    required: !0,
    type: [String, Array]
  },
  checkInDate: {
    required: !0,
    type: String
  },
  initialDate: {
    type: String
  },
  timezone: {
    required: !0,
    type: String
  }
}, nu = {
  ...Jt,
  tagClasses: { type: String }
}, iu = {
  amount: {
    required: !0,
    type: Number
  },
  currency: {
    required: !0,
    type: String
  },
  disabled: {
    default: !1,
    type: Boolean
  },
  loading: {
    default: !1,
    type: Boolean
  },
  stripeToken: { required: !0, type: String },
  withAction: {
    default: !1,
    type: Boolean
  },
  withTerms: {
    default: !1,
    type: Boolean
  }
}, ou = {
  features: {
    default: () => vt,
    type: [Object, String]
  },
  token: { type: String }
}, lu = {
  color: {
    default: "primary",
    type: String
  },
  dialog: {
    default: !1,
    type: Boolean
  },
  elevation: {
    default: 0,
    type: [String, Number]
  },
  size: {
    default: 0,
    type: [String, Number]
  }
}, ba = {
  adultCount: { required: !0, type: Number },
  bookingId: { type: String },
  bookingPolicyId: { required: !0, type: String },
  checkInDate: { required: !0, type: String },
  checkOutDate: { required: !0, type: String },
  emailAddress: {
    default: "",
    type: String
  },
  features: {
    default: () => Da,
    type: [Object, String]
  },
  firstName: {
    default: "",
    type: String
  },
  hotelRoomOffer: { type: [Object, String] },
  lastName: {
    default: "",
    type: String
  },
  nationality: {
    default: "",
    type: String
  },
  organizationAddress: {
    default: "",
    type: String
  },
  organizationCity: {
    default: "",
    type: String
  },
  organizationCountry: {
    default: "",
    type: String
  },
  organizationName: {
    default: "",
    type: String
  },
  organizationState: {
    default: "",
    type: String
  },
  organizationVatNumber: {
    default: "",
    type: String
  },
  organizationZipCode: {
    default: "",
    type: String
  },
  paymentMethods: {
    default: Zn.CreditCard,
    type: String
  },
  phoneCountry: {
    default: "FR",
    type: String
  },
  phoneNumber: {
    default: "",
    type: String
  },
  roomCount: { required: !0, type: Number },
  salutation: {
    default: "",
    type: String
  },
  specialRequests: {
    default: "",
    type: String
  }
}, Xt = {
  address: {
    type: String
  },
  adultCount: {
    required: !0,
    type: Number
  },
  checkInDate: {
    required: !0,
    type: String
  },
  checkOutDate: {
    required: !0,
    type: String
  },
  children: {
    default: null,
    type: [String, null]
  },
  hotelOfferRequestId: {
    type: String
  },
  latitude: {
    required: !0,
    type: Number
  },
  longitude: {
    required: !0,
    type: Number
  },
  roomCount: {
    required: !0,
    type: Number
  },
  sourceMarket: {
    required: !0,
    type: String
  }
}, Qt = {
  ...Xt,
  features: {
    default: () => Ct,
    type: [Object, String]
  },
  height: {
    default: "600px",
    type: [Number, String]
  },
  hotelRoomOffersLimit: {
    type: Number
  },
  isLoadingBarEnabled: {
    default: !0,
    type: Boolean
  },
  limit: {
    default: bt,
    type: Number
  },
  maxHeight: {
    default: "90vh",
    type: [Number, String]
  },
  rounded: {
    default: !0,
    type: Boolean
  }
}, er = {
  ...Xt,
  features: {
    default: () => ga,
    type: [Object, String]
  },
  height: {
    default: "600px",
    type: [Number, String]
  },
  hoveredHotel: {
    default: "",
    type: String
  },
  isLoadingBarEnabled: {
    default: !0,
    type: Boolean
  },
  limit: {
    default: bt,
    type: Number
  },
  markers: {
    default: () => [],
    type: [String, Array]
  },
  maxHeight: {
    default: "90vh",
    type: [Number, String]
  },
  venue: {
    type: [String, Object]
  }
}, ar = {
  ...Qt,
  ...er,
  features: {
    default: () => Zt,
    type: [Object, String]
  },
  mapFirstOnMobile: {
    default: !0,
    type: Boolean
  }
}, su = {
  ...ar,
  ...fa(ba, ["bookingId"]),
  features: {
    default: () => Xs,
    type: [Object, String]
  }
}, uu = {
  address: {
    required: !0,
    type: String
  },
  adultCount: {
    required: !0,
    type: Number
  },
  checkInDate: {
    required: !0,
    type: String
  },
  checkOutDate: {
    required: !0,
    type: String
  },
  children: {
    default: null,
    type: [String, null]
  },
  isLoadingBarEnabled: {
    default: !1,
    type: Boolean
  },
  latitude: {
    required: !0,
    type: Number
  },
  longitude: {
    required: !0,
    type: Number
  },
  roomCount: {
    required: !0,
    type: Number
  },
  sourceMarket: {
    required: !0,
    type: String
  }
}, va = {
  adultCount: {
    required: !0,
    type: Number
  },
  checkInDate: {
    required: !0,
    type: String
  },
  checkOutDate: {
    required: !0,
    type: String
  },
  children: {
    default: null,
    type: String
  },
  hotelId: {
    required: !0,
    type: String
  },
  hotelRoomOfferRequestId: {
    type: String
  },
  roomCount: {
    required: !0,
    type: Number
  },
  sourceMarket: {
    required: !0,
    type: String
  }
}, tr = {
  ...va,
  features: {
    default: () => Wt,
    type: [Object, String]
  },
  limit: {
    default: () => 0,
    type: Number
  }
}, cu = {
  features: {
    default: () => Vt,
    type: [Object, String]
  },
  hotelId: { type: String }
}, rr = {
  ...va,
  ...fa(tr, "features"),
  features: {
    default: () => qt,
    type: [Object, String]
  }
}, mu = {
  ...rr,
  ...fa(ba, ["bookingId", "bookingPolicyId", "hotelRoomOffer"]),
  features: {
    default: () => Qs,
    type: [Object, String]
  }
}, du = {
  elevation: {
    default: 0,
    type: [String, Number]
  }
}, fu = {
  boilerplate: {
    default: !1,
    required: !1,
    type: Boolean
  },
  token: {
    required: !0,
    type: String
  }
}, gu = {
  theme: {
    default: "light",
    type: String
  }
}, nr = w(
  "revolugo-bank-transfer-details",
  au
), ir = w(
  "revolugo-booking-details-sidebar",
  tu
), or = w(
  "revolugo-booking-manager",
  ru
), lr = w(
  "revolugo-cancellation-policies-badge",
  nu
), sr = w(
  "revolugo-cancellation-policies-list",
  Jt
), ur = w(
  "revolugo-credit-card-stripe-form",
  iu
), cr = w(
  "revolugo-booking-payment-form",
  ou
), mr = w(
  "revolugo-currency-picker-btn",
  lu
), dr = w(
  "revolugo-full-booking-flow",
  su
), fr = w(
  "revolugo-hotel-description-view",
  cu
), gr = w(
  "revolugo-hotel-offers-map",
  er
), Dr = w(
  "revolugo-hotel-offers-view",
  ar
), br = w(
  "revolugo-hotel-offer-list",
  Qt
), vr = w(
  "revolugo-hotel-offer-search-menu",
  uu
), pr = w(
  "revolugo-hotel-room-offers-booking-flow",
  mu
), hr = w(
  "revolugo-hotel-room-offers-view",
  rr
), yr = w(
  "revolugo-hotel-room-offer-list",
  tr
), Sr = w(
  "revolugo-hotel-room-offer-search-menu",
  va
), Pr = w(
  "revolugo-lang-picker-btn",
  du
), Nr = w(
  "revolugo-prebook-form",
  ba
), Rr = w(
  "revolugo-preferences-menu",
  eu
), Mr = w(
  "revolugo-rooming-list-editor",
  fu
), Ar = w(
  "revolugo-terms-and-conditions",
  gu
), Du = {
  RevolugoVueBankTransferDetails: nr,
  RevolugoVueBookingDetailsSidebar: ir,
  RevolugoVueBookingManager: or,
  RevolugoVueCancellationPoliciesBadge: lr,
  RevolugoVueCancellationPoliciesList: sr,
  RevolugoVueCreditCardStripeForm: ur,
  RevolugoVueBookingPaymentForm: cr,
  RevolugoVueCurrencyPickerBtn: mr,
  RevolugoVueFullBookingFlow: dr,
  RevolugoVueHotelDescriptionView: fr,
  RevolugoVueHotelOffersMap: gr,
  RevolugoVueHotelOffersView: Dr,
  RevolugoVueHotelOfferList: br,
  RevolugoVueHotelOfferSearchMenu: vr,
  RevolugoVueHotelRoomOffersBookingFlow: pr,
  RevolugoVueHotelRoomOffersView: hr,
  RevolugoVueHotelRoomOfferList: yr,
  RevolugoVueHotelRoomOfferSearchMenu: Sr,
  RevolugoVueLangPickerBtn: Pr,
  RevolugoVuePrebookForm: Nr,
  RevolugoVuePreferencesMenu: Rr,
  RevolugoVueRoomingListEditor: Mr,
  RevolugoVueTermsAndConditions: Ar
}, xe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  RevolugoVueBankTransferDetails: nr,
  RevolugoVueBookingDetailsSidebar: ir,
  RevolugoVueBookingManager: or,
  RevolugoVueBookingPaymentForm: cr,
  RevolugoVueCancellationPoliciesBadge: lr,
  RevolugoVueCancellationPoliciesList: sr,
  RevolugoVueCreditCardStripeForm: ur,
  RevolugoVueCurrencyPickerBtn: mr,
  RevolugoVueFullBookingFlow: dr,
  RevolugoVueHotelDescriptionView: fr,
  RevolugoVueHotelOfferList: br,
  RevolugoVueHotelOfferSearchMenu: vr,
  RevolugoVueHotelOffersMap: gr,
  RevolugoVueHotelOffersView: Dr,
  RevolugoVueHotelRoomOfferList: yr,
  RevolugoVueHotelRoomOfferSearchMenu: Sr,
  RevolugoVueHotelRoomOffersBookingFlow: pr,
  RevolugoVueHotelRoomOffersView: hr,
  RevolugoVueLangPickerBtn: Pr,
  RevolugoVuePrebookForm: Nr,
  RevolugoVuePreferencesMenu: Rr,
  RevolugoVueRoomingListEditor: Mr,
  RevolugoVueTermsAndConditions: Ar,
  default: Du
}, Symbol.toStringTag, { value: "Module" }));
async function bu(e, a) {
  if (e.config.compilerOptions.isCustomElement = (t) => t.startsWith("revolugo-") && !t.startsWith("revolugo-vue"), window.RevolugoElements = window.RevolugoElements || {}, !a)
    throw new Error("Revolugo Vue3 Plugin: config is required");
  if (window.RevolugoElements.config = a, await $r(a.next), a.installComponents)
    for (const t in xe)
      t !== "default" && e.component(
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        xe[t].name,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        xe[t]
      );
}
const hu = { install: bu };
export {
  jn as BookingState,
  Dt as Event,
  hu as RevolugoElementsPlugin,
  nr as RevolugoVueBankTransferDetails,
  ir as RevolugoVueBookingDetailsSidebar,
  or as RevolugoVueBookingManager,
  cr as RevolugoVueBookingPaymentForm,
  lr as RevolugoVueCancellationPoliciesBadge,
  sr as RevolugoVueCancellationPoliciesList,
  ur as RevolugoVueCreditCardStripeForm,
  mr as RevolugoVueCurrencyPickerBtn,
  dr as RevolugoVueFullBookingFlow,
  fr as RevolugoVueHotelDescriptionView,
  br as RevolugoVueHotelOfferList,
  vr as RevolugoVueHotelOfferSearchMenu,
  gr as RevolugoVueHotelOffersMap,
  Dr as RevolugoVueHotelOffersView,
  yr as RevolugoVueHotelRoomOfferList,
  Sr as RevolugoVueHotelRoomOfferSearchMenu,
  pr as RevolugoVueHotelRoomOffersBookingFlow,
  hr as RevolugoVueHotelRoomOffersView,
  Pr as RevolugoVueLangPickerBtn,
  Nr as RevolugoVuePrebookForm,
  Rr as RevolugoVuePreferencesMenu,
  Mr as RevolugoVueRoomingListEditor,
  Ar as RevolugoVueTermsAndConditions,
  pu as lightTheme
};
//# sourceMappingURL=elements-vue3.es.js.map
